// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Ids Button Component CSS
 * (Includes standard and icon button rules)
 */
/**
 * Ids Button Sass mixins, used in Ids Button CSS to define base styles.
 */
/**
 * Provides standardized padding rules for certain button types
 */
/**
 * Provides the standard color rules for all regular buttons
 */
/**
 * Provides the standard color rules for buttons that need box shadow
 */
:host {
  display: inline-flex;
  vertical-align: middle;
}
:host ::slotted(span) {
  vertical-align: bottom;
}
:host ::slotted(span),
:host ::slotted(ids-text) {
  color: currentColor;
  align-self: center;
}
:host ::slotted(ids-icon) {
  vertical-align: middle;
  color: currentColor;
}
:host ::slotted(ids-icon[compact=true]) {
  margin-inline-end: var(--ids-space-2xs);
}
:host ::slotted(span.audible) {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
:host button,
:host .ids-icon-button {
  justify-content: center;
  height: 100%;
  width: 100%;
}

:host(.hidden) {
  display: none;
}

:host([system-button]) button:not(.is-active):hover {
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-system-color-text-hover);
}

:host([hidden]) {
  display: none;
}

button {
  display: block;
}

.ids-button,
.ids-toggle-button,
.ids-menu-button:not(.ids-icon-button),
.ids-modal-button {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ids-button .ids-icon,
.ids-toggle-button .ids-icon,
.ids-menu-button:not(.ids-icon-button) .ids-icon,
.ids-modal-button .ids-icon {
  display: inline-flex;
  place-self: center;
  vertical-align: middle;
}

.ids-button.compact,
.ids-icon-button.compact {
  font-size: var(--ids-font-size-2xs);
  height: var(--ids-button-compact-width);
  line-height: 16px;
}

.ids-button.ellipsis ::slotted(span) {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: inherit;
  height: inherit;
}

.ids-button,
.ids-toggle-button,
.ids-menu-button {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
}
.ids-button, .ids-button::before, .ids-button::after,
.ids-toggle-button,
.ids-toggle-button::before,
.ids-toggle-button::after,
.ids-menu-button,
.ids-menu-button::before,
.ids-menu-button::after {
  box-sizing: border-box;
}
.ids-button *,
.ids-toggle-button *,
.ids-menu-button * {
  pointer-events: none;
}
.ids-button,
.ids-toggle-button,
.ids-menu-button {
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
}
.ids-button:focus,
.ids-toggle-button:focus,
.ids-menu-button:focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-button:not([disabled]),
.ids-toggle-button:not([disabled]),
.ids-menu-button:not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-button span,
.ids-toggle-button span,
.ids-menu-button span {
  vertical-align: bottom;
}
.ids-button span.audible,
.ids-toggle-button span.audible,
.ids-menu-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])),
.ids-toggle-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])),
.ids-menu-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-button .ids-icon,
.ids-toggle-button .ids-icon,
.ids-menu-button .ids-icon {
  vertical-align: middle;
}
.ids-button.align-icon-end ::slotted(ids-icon),
.ids-toggle-button.align-icon-end ::slotted(ids-icon),
.ids-menu-button.align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-button.content-align-start,
.ids-toggle-button.content-align-start,
.ids-menu-button.content-align-start {
  justify-content: start;
}
.ids-button.content-align-end,
.ids-toggle-button.content-align-end,
.ids-menu-button.content-align-end {
  justify-content: end;
}
.ids-button.no-margins,
.ids-toggle-button.no-margins,
.ids-menu-button.no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-button.field-height-xxs:not(.btn-secondary):not(.no-margins),
.ids-toggle-button.field-height-xxs:not(.btn-secondary):not(.no-margins),
.ids-menu-button.field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-button ::slotted(span),
.ids-toggle-button ::slotted(span),
.ids-menu-button ::slotted(span) {
  font-weight: inherit !important;
}
.ids-button,
.ids-toggle-button,
.ids-menu-button {
  display: inline-flex;
  font-weight: var(--ids-button-tertiary-font-weight);
  border-radius: var(--ids-button-radius);
  background-color: var(--ids-button-tertiary-color-background-default);
  border-color: var(--ids-button-tertiary-color-border-default);
  color: var(--ids-button-tertiary-color-text-default);
}
.ids-button:not(.hide-focus).is-active:not([readonly]), .ids-button:not(.hide-focus).is-focused:not([readonly]), .ids-button:not(.hide-focus):focus:not([readonly]), .ids-button:not(.hide-focus):focus-within:not([readonly]),
.ids-toggle-button:not(.hide-focus).is-active:not([readonly]),
.ids-toggle-button:not(.hide-focus).is-focused:not([readonly]),
.ids-toggle-button:not(.hide-focus):focus:not([readonly]),
.ids-toggle-button:not(.hide-focus):focus-within:not([readonly]),
.ids-menu-button:not(.hide-focus).is-active:not([readonly]),
.ids-menu-button:not(.hide-focus).is-focused:not([readonly]),
.ids-menu-button:not(.hide-focus):focus:not([readonly]),
.ids-menu-button:not(.hide-focus):focus-within:not([readonly]) {
  border-color: var(--ids-button-tertiary-color-border-focus);
}
.ids-button:hover,
.ids-toggle-button:hover,
.ids-menu-button:hover {
  color: var(--ids-button-tertiary-color-text-hover);
  background-color: var(--ids-button-tertiary-color-background-hover);
  border-color: var(--ids-button-tertiary-color-border-hover);
}
.ids-button[disabled],
.ids-toggle-button[disabled],
.ids-menu-button[disabled] {
  color: var(--ids-button-tertiary-color-text-disabled);
  background-color: var(--ids-button-tertiary-color-background-disabled);
  border-color: var(--ids-button-tertiary-color-border-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-button:active:not([disabled]),
.ids-toggle-button:active:not([disabled]),
.ids-menu-button:active:not([disabled]) {
  background-color: var(--ids-button-tertiary-color-background-pressed);
  border-color: var(--ids-button-tertiary-color-border-pressed);
  color: var(--ids-button-tertiary-color-text-pressed);
}
.ids-button.btn-tertiary-destructive,
.ids-toggle-button.btn-tertiary-destructive,
.ids-menu-button.btn-tertiary-destructive {
  background-color: var(--ids-button-destructive-tertiary-color-background-default);
  border-color: var(--ids-button-destructive-tertiary-color-border-default);
  color: var(--ids-button-destructive-tertiary-color-text-default);
}
.ids-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-tertiary-color-border-focus);
}
.ids-button.btn-tertiary-destructive:hover,
.ids-toggle-button.btn-tertiary-destructive:hover,
.ids-menu-button.btn-tertiary-destructive:hover {
  background-color: var(--ids-button-destructive-tertiary-color-background-hover);
  border-color: var(--ids-button-destructive-tertiary-color-border-hover);
  color: var(--ids-button-destructive-tertiary-color-text-hover);
}
.ids-button.btn-tertiary-destructive[disabled],
.ids-toggle-button.btn-tertiary-destructive[disabled],
.ids-menu-button.btn-tertiary-destructive[disabled] {
  color: var(--ids-button-destructive-tertiary-color-text-disabled);
  background-color: var(--ids-button-destructive-tertiary-color-background-disabled);
  border-color: var(--ids-button-destructive-tertiary-color-border-disabled);
}
.ids-button.btn-primary,
.ids-toggle-button.btn-primary,
.ids-menu-button.btn-primary {
  background-color: var(--ids-button-primary-color-background-default);
  border-color: var(--ids-button-primary-color-border-default);
  border: 1px solid var(--ids-button-primary-color-border-default);
  color: var(--ids-button-primary-color-text-default);
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
}
.ids-button.btn-primary:not(.hide-focus).is-active, .ids-button.btn-primary:not(.hide-focus).is-focused, .ids-button.btn-primary:not(.hide-focus).focus-within, .ids-button.btn-primary:not(.hide-focus):focus,
.ids-toggle-button.btn-primary:not(.hide-focus).is-active,
.ids-toggle-button.btn-primary:not(.hide-focus).is-focused,
.ids-toggle-button.btn-primary:not(.hide-focus).focus-within,
.ids-toggle-button.btn-primary:not(.hide-focus):focus,
.ids-menu-button.btn-primary:not(.hide-focus).is-active,
.ids-menu-button.btn-primary:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary:not(.hide-focus):focus {
  border-color: var(--ids-button-primary-color-border-focus);
}
.ids-button.btn-primary:hover,
.ids-toggle-button.btn-primary:hover,
.ids-menu-button.btn-primary:hover {
  background-color: var(--ids-button-primary-color-background-hover);
  border-color: var(--ids-button-primary-color-border-hover);
}
.ids-button.btn-primary[disabled],
.ids-toggle-button.btn-primary[disabled],
.ids-menu-button.btn-primary[disabled] {
  background-color: var(--ids-button-primary-color-background-disabled);
  border-color: var(--ids-button-primary-color-border-disabled);
  color: var(--ids-button-primary-color-text-disabled);
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-button.btn-primary:active:not([disabled]),
.ids-toggle-button.btn-primary:active:not([disabled]),
.ids-menu-button.btn-primary:active:not([disabled]) {
  background-color: var(--ids-button-primary-color-background-pressed);
  border-color: var(--ids-button-primary-color-border-pressed);
  color: var(--ids-button-primary-color-text-pressed);
}
.ids-button.btn-primary-destructive,
.ids-toggle-button.btn-primary-destructive,
.ids-menu-button.btn-primary-destructive {
  background-color: var(--ids-button-destructive-color-background-default);
  border-color: var(--ids-button-destructive-color-border-default);
  color: var(--ids-button-destructive-color-text-default);
}
.ids-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-color-border-focus);
}
.ids-button.btn-primary-destructive:hover,
.ids-toggle-button.btn-primary-destructive:hover,
.ids-menu-button.btn-primary-destructive:hover {
  background-color: var(--ids-button-destructive-color-background-hover);
  border-color: var(--ids-button-destructive-color-border-hover);
  color: var(--ids-button-destructive-color-text-hover);
}
.ids-button.btn-primary-destructive[disabled],
.ids-toggle-button.btn-primary-destructive[disabled],
.ids-menu-button.btn-primary-destructive[disabled] {
  background-color: var(--ids-button-destructive-color-background-disabled);
  border-color: var(--ids-button-destructive-color-border-disabled);
  color: var(--ids-button-destructive-color-text-disabled);
  opacity: var(--ids-button-destructive-opacity-disabled);
}
@keyframes dot-flashing {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-2);
  }
}
@keyframes dot-flashing-colors-secondary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-2);
  }
}
@keyframes dot-flashing-colors-tertiary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-2);
  }
}
.ids-button .loading-dots-start,
.ids-toggle-button .loading-dots-start,
.ids-menu-button .loading-dots-start {
  padding-inline-start: 3px !important;
  padding-inline-end: 7px !important;
  gap: 2px;
}
.ids-button .loading-dots,
.ids-toggle-button .loading-dots,
.ids-menu-button .loading-dots {
  display: none;
  position: relative;
  flex-direction: row;
  gap: 2px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
}
.ids-button .loading-dots .dot,
.ids-toggle-button .loading-dots .dot,
.ids-menu-button .loading-dots .dot {
  display: inline-flex;
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: var(--ids-button-ai-color-loading-dot-default);
  color: var(--ids-button-ai-color-loading-dot-default);
}
.ids-button.btn-primary-generative-ai,
.ids-toggle-button.btn-primary-generative-ai,
.ids-menu-button.btn-primary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-primary-sparkle-icon-color-fill);
  background: border-box var(--ids-button-ai-color-background-default);
  border: none;
  color: var(--ids-button-ai-color-text-default);
  align-items: center;
  min-width: 34px;
  min-height: 34px;
}
.ids-button.btn-primary-generative-ai.compact,
.ids-toggle-button.btn-primary-generative-ai.compact,
.ids-menu-button.btn-primary-generative-ai.compact {
  min-width: var(--ids-button-compact-width);
  min-height: var(--ids-button-compact-width);
}
.ids-button.btn-primary-generative-ai:hover,
.ids-toggle-button.btn-primary-generative-ai:hover,
.ids-menu-button.btn-primary-generative-ai:hover {
  background: border-box var(--ids-button-ai-color-background-hover);
}
.ids-button.btn-primary-generative-ai:active, .ids-button.btn-primary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-primary-generative-ai:active,
.ids-toggle-button.btn-primary-generative-ai.gen-ai-active,
.ids-menu-button.btn-primary-generative-ai:active,
.ids-menu-button.btn-primary-generative-ai.gen-ai-active {
  background: border-box var(--ids-button-ai-color-background-active);
  color: var(--ids-button-ai-color-text-active);
}
.ids-button.btn-primary-generative-ai[disabled],
.ids-toggle-button.btn-primary-generative-ai[disabled],
.ids-menu-button.btn-primary-generative-ai[disabled] {
  background: border-box var(--ids-button-ai-color-background-disabled);
}
.ids-button.btn-primary-generative-ai.color-variant-alternate-formatter, .ids-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover,
.ids-toggle-button.btn-primary-generative-ai.color-variant-alternate-formatter,
.ids-toggle-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover,
.ids-menu-button.btn-primary-generative-ai.color-variant-alternate-formatter,
.ids-menu-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover {
  color: var(--ids-color-white-100);
  min-height: var(--ids-button-formatter-size);
  min-width: 34px;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-secondary-generative-ai,
.ids-toggle-button.btn-secondary-generative-ai,
.ids-menu-button.btn-secondary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-secondary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-secondary-color-background-default);
  border: 1px solid var(--ids-button-ai-secondary-color-border-default);
  color: var(--ids-button-ai-secondary-color-default);
  align-items: center;
}
.ids-button.btn-secondary-generative-ai:hover:not([disabled]),
.ids-toggle-button.btn-secondary-generative-ai:hover:not([disabled]),
.ids-menu-button.btn-secondary-generative-ai:hover:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-hover);
  color: var(--ids-button-ai-secondary-color-hover);
  border-color: var(--ids-button-ai-secondary-color-border-hover);
}
.ids-button.btn-secondary-generative-ai:active:not([disabled]),
.ids-toggle-button.btn-secondary-generative-ai:active:not([disabled]),
.ids-menu-button.btn-secondary-generative-ai:active:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-active);
  color: var(--ids-button-ai-secondary-color-active);
  border-color: var(--ids-button-ai-secondary-color-border-active);
}
.ids-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-toggle-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-menu-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);
}
.ids-button.btn-secondary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-secondary-generative-ai.gen-ai-active,
.ids-menu-button.btn-secondary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-secondary-color-background-active);
}
.ids-button.btn-secondary-generative-ai[disabled],
.ids-toggle-button.btn-secondary-generative-ai[disabled],
.ids-menu-button.btn-secondary-generative-ai[disabled] {
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot,
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot,
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot {
  background-color: var(--ids-button-ai-color-loading-dot-secondary);
  color: var(--ids-button-ai-color-loading-dot-secondary);
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-secondary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-tertiary-generative-ai,
.ids-toggle-button.btn-tertiary-generative-ai,
.ids-menu-button.btn-tertiary-generative-ai {
  --ids-button-tertiary-ai-shadow-focus: var(--ids-button-tertiary-shadow-focus);
  --ids-button-ai-color-icon-secondary-hover: var(--ids-color-action-stronger);
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-tertiary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-tertiary-color-background-default);
  background-clip: text;
  align-items: center;
  color: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-button.btn-tertiary-generative-ai:hover,
.ids-toggle-button.btn-tertiary-generative-ai:hover,
.ids-menu-button.btn-tertiary-generative-ai:hover {
  background: var(--ids-button-ai-tertiary-color-background-hover);
}
.ids-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-toggle-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-menu-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-tertiary-color-text-default);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-button.btn-tertiary-generative-ai:active, .ids-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-tertiary-generative-ai:active,
.ids-toggle-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-menu-button.btn-tertiary-generative-ai:active,
.ids-menu-button.btn-tertiary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-tertiary-color-background-active);
}
.ids-button.btn-tertiary-generative-ai[disabled],
.ids-toggle-button.btn-tertiary-generative-ai[disabled],
.ids-menu-button.btn-tertiary-generative-ai[disabled] {
  background: var(--ids-button-tertiary-ai-color-background-disabled);
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-tertiary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-secondary,
.ids-toggle-button.btn-secondary,
.ids-menu-button.btn-secondary {
  background-color: var(--ids-button-secondary-color-background-default);
  border-width: var(--ids-button-secondary-border-width);
  border-color: var(--ids-button-secondary-color-border-default);
  color: var(--ids-button-secondary-color-text-default);
}
.ids-button.btn-secondary:not(.hide-focus).is-active, .ids-button.btn-secondary:not(.hide-focus).is-focused, .ids-button.btn-secondary:not(.hide-focus).focus-within, .ids-button.btn-secondary:not(.hide-focus):focus,
.ids-toggle-button.btn-secondary:not(.hide-focus).is-active,
.ids-toggle-button.btn-secondary:not(.hide-focus).is-focused,
.ids-toggle-button.btn-secondary:not(.hide-focus).focus-within,
.ids-toggle-button.btn-secondary:not(.hide-focus):focus,
.ids-menu-button.btn-secondary:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary:not(.hide-focus):focus {
  background-color: var(--ids-button-secondary-color-background-focus);
  border-color: var(--ids-button-secondary-color-border-focus);
}
.ids-button.btn-secondary:hover:not([disabled]),
.ids-toggle-button.btn-secondary:hover:not([disabled]),
.ids-menu-button.btn-secondary:hover:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-hover);
  border-color: var(--ids-button-secondary-color-border-hover);
  color: var(--ids-button-secondary-color-text-hover);
}
.ids-button.btn-secondary[disabled],
.ids-toggle-button.btn-secondary[disabled],
.ids-menu-button.btn-secondary[disabled] {
  background-color: var(--ids-button-secondary-color-background-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
  color: var(--ids-button-secondary-color-text-disabled);
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-button.btn-secondary:active:not([disabled]),
.ids-toggle-button.btn-secondary:active:not([disabled]),
.ids-menu-button.btn-secondary:active:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-pressed);
  border-color: var(--ids-button-secondary-color-border-pressed);
  color: var(--ids-button-secondary-color-text-pressed);
}
.ids-button.color-variant-alternate:hover,
.ids-toggle-button.color-variant-alternate:hover,
.ids-menu-button.color-variant-alternate:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.ids-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover,
.ids-toggle-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover,
.ids-menu-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover {
  background-color: var(--ids-search-field-header-color-icon-hover);
}
.ids-button.color-variant-app-menu:hover,
.ids-toggle-button.color-variant-app-menu:hover,
.ids-menu-button.color-variant-app-menu:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.ids-button.color-variant-alternate, .ids-button.color-variant-alternate-formatter,
.ids-toggle-button.color-variant-alternate,
.ids-toggle-button.color-variant-alternate-formatter,
.ids-menu-button.color-variant-alternate,
.ids-menu-button.color-variant-alternate-formatter {
  color: var(--ids-button-alternate-color-text-default);
  opacity: 0.8;
}
.ids-button.color-variant-alternate:not(.hide-focus).is-active, .ids-button.color-variant-alternate:not(.hide-focus).is-focused, .ids-button.color-variant-alternate:not(.hide-focus).focus-within, .ids-button.color-variant-alternate:not(.hide-focus):focus, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-button-formatter-color-border-focus);
  opacity: 1;
}
.ids-button.color-variant-alternate:hover, .ids-button.color-variant-alternate-formatter:hover,
.ids-toggle-button.color-variant-alternate:hover,
.ids-toggle-button.color-variant-alternate-formatter:hover,
.ids-menu-button.color-variant-alternate:hover,
.ids-menu-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-formatter-color-text-hover);
  opacity: 1;
}
.ids-button.color-variant-alternate[disabled], .ids-button.color-variant-alternate-formatter[disabled],
.ids-toggle-button.color-variant-alternate[disabled],
.ids-toggle-button.color-variant-alternate-formatter[disabled],
.ids-menu-button.color-variant-alternate[disabled],
.ids-menu-button.color-variant-alternate-formatter[disabled] {
  background-color: var(--ids-color-transparent);
  opacity: var(--ids-button-formatter-opacity-disabled);
}
.ids-button.color-variant-alternate-formatter,
.ids-toggle-button.color-variant-alternate-formatter,
.ids-menu-button.color-variant-alternate-formatter {
  background-color: var(--ids-button-formatter-color-background-default);
  border-color: var(--ids-button-formatter-color-border-default);
  color: var(--ids-button-formatter-color-text-default);
  height: var(--ids-button-formatter-size);
  min-width: var(--ids-button-formatter-size);
}
.ids-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-color-border-focus);
}
.ids-button.color-variant-alternate-formatter[disabled],
.ids-toggle-button.color-variant-alternate-formatter[disabled],
.ids-menu-button.color-variant-alternate-formatter[disabled] {
  color: var(--ids-button-formatter-color-text-disabled);
}
.ids-button.color-variant-alternate-formatter:hover,
.ids-toggle-button.color-variant-alternate-formatter:hover,
.ids-menu-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  color: var(--ids-button-formatter-color-text-hover);
}
.ids-button.color-variant-alternate-formatter.is-active,
.ids-toggle-button.color-variant-alternate-formatter.is-active,
.ids-menu-button.color-variant-alternate-formatter.is-active {
  color: var(--ids-button-formatter-color-active);
}
.ids-button.color-variant-alternate-formatter.ids-menu-button.compact,
.ids-toggle-button.color-variant-alternate-formatter.ids-menu-button.compact,
.ids-menu-button.color-variant-alternate-formatter.ids-menu-button.compact {
  padding: var(--ids-space-2xs);
  padding-inline: var(--ids-space-2xs);
}
.ids-button.color-variant-alternate-formatter.ids-menu-button.compact.square,
.ids-toggle-button.color-variant-alternate-formatter.ids-menu-button.compact.square,
.ids-menu-button.color-variant-alternate-formatter.ids-menu-button.compact.square {
  border-radius: var(--ids-border-radius-xs);
  width: 34px;
}
.ids-button.color-variant-alternate-formatter[editor-action=sourcemode], .ids-button.color-variant-alternate-formatter[editor-action=editormode],
.ids-toggle-button.color-variant-alternate-formatter[editor-action=sourcemode],
.ids-toggle-button.color-variant-alternate-formatter[editor-action=editormode],
.ids-menu-button.color-variant-alternate-formatter[editor-action=sourcemode],
.ids-menu-button.color-variant-alternate-formatter[editor-action=editormode] {
  --ids-button-icon-width: 54px;
}
.ids-button.color-variant-module,
.ids-toggle-button.color-variant-module,
.ids-menu-button.color-variant-module {
  border: 0;
  color: var(--ids-button-module-color-text-default);
}
.ids-button.color-variant-module:not(.square),
.ids-toggle-button.color-variant-module:not(.square),
.ids-menu-button.color-variant-module:not(.square) {
  border-radius: var(--ids-button-module-border-radius);
}
.ids-button.color-variant-module:hover,
.ids-toggle-button.color-variant-module:hover,
.ids-menu-button.color-variant-module:hover {
  background-color: var(--ids-button-module-color-background-hover);
  color: var(--ids-button-module-color-text-hover);
}
.ids-button:not(.no-padding),
.ids-toggle-button:not(.no-padding),
.ids-menu-button:not(.no-padding) {
  padding-inline: var(--ids-button-padding-inline);
}
.ids-button.btn-tertiary, .ids-button.btn-tertiary-destructive,
.ids-toggle-button.btn-tertiary,
.ids-toggle-button.btn-tertiary-destructive,
.ids-menu-button.btn-tertiary,
.ids-menu-button.btn-tertiary-destructive {
  padding-inline: var(--ids-space-12);
}
.ids-button.no-padding,
.ids-toggle-button.no-padding,
.ids-menu-button.no-padding {
  padding-inline: var(--ids-space-12);
}

.ids-menu-button.sub-tab-button.is-active {
  background-color: unset;
}

.ids-menu-button.is-active,
.ids-menu-button.is-active:hover {
  background-color: var(--ids-button-menu-background-color-active);
  color: var(--ids-button-menu-color-text-active);
}

.ids-menu-button.formatter-width:not(.no-padding):not(.ids-icon-button) {
  padding-inline-start: calc(var(--ids-space-xs) - 1px);
  padding-inline-end: calc(var(--ids-space-xs) - 1px);
}
.ids-menu-button.formatter-width:not(.formatter-width-percentage) {
  justify-content: normal;
}
.ids-menu-button.formatter-width:not(.formatter-width-percentage) .ids-icon {
  position: absolute;
  inset-inline-end: var(--ids-space-2xs);
}

::slotted(ids-icon[icon=logo]) {
  height: 30px;
  opacity: 0.8;
}

.ids-icon-button {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  /* stylelint-disable-next-line no-duplicate-selectors */
}
.ids-icon-button, .ids-icon-button::before, .ids-icon-button::after {
  box-sizing: border-box;
}
.ids-icon-button * {
  pointer-events: none;
}
.ids-icon-button {
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
}
.ids-icon-button:focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-icon-button:not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-icon-button span {
  vertical-align: bottom;
}
.ids-icon-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-icon-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-icon-button .ids-icon {
  vertical-align: middle;
}
.ids-icon-button.align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-icon-button.content-align-start {
  justify-content: start;
}
.ids-icon-button.content-align-end {
  justify-content: end;
}
.ids-icon-button.no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-icon-button.field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-icon-button ::slotted(span) {
  font-weight: inherit !important;
}
.ids-icon-button {
  display: inline-flex;
  font-weight: var(--ids-button-tertiary-font-weight);
  border-radius: var(--ids-button-radius);
  background-color: var(--ids-button-tertiary-color-background-default);
  border-color: var(--ids-button-tertiary-color-border-default);
  color: var(--ids-button-tertiary-color-text-default);
}
.ids-icon-button:not(.hide-focus).is-active:not([readonly]), .ids-icon-button:not(.hide-focus).is-focused:not([readonly]), .ids-icon-button:not(.hide-focus):focus:not([readonly]), .ids-icon-button:not(.hide-focus):focus-within:not([readonly]) {
  border-color: var(--ids-button-tertiary-color-border-focus);
}
.ids-icon-button:hover {
  color: var(--ids-button-tertiary-color-text-hover);
  background-color: var(--ids-button-tertiary-color-background-hover);
  border-color: var(--ids-button-tertiary-color-border-hover);
}
.ids-icon-button[disabled] {
  color: var(--ids-button-tertiary-color-text-disabled);
  background-color: var(--ids-button-tertiary-color-background-disabled);
  border-color: var(--ids-button-tertiary-color-border-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-icon-button:active:not([disabled]) {
  background-color: var(--ids-button-tertiary-color-background-pressed);
  border-color: var(--ids-button-tertiary-color-border-pressed);
  color: var(--ids-button-tertiary-color-text-pressed);
}
.ids-icon-button.btn-tertiary-destructive {
  background-color: var(--ids-button-destructive-tertiary-color-background-default);
  border-color: var(--ids-button-destructive-tertiary-color-border-default);
  color: var(--ids-button-destructive-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-tertiary-color-border-focus);
}
.ids-icon-button.btn-tertiary-destructive:hover {
  background-color: var(--ids-button-destructive-tertiary-color-background-hover);
  border-color: var(--ids-button-destructive-tertiary-color-border-hover);
  color: var(--ids-button-destructive-tertiary-color-text-hover);
}
.ids-icon-button.btn-tertiary-destructive[disabled] {
  color: var(--ids-button-destructive-tertiary-color-text-disabled);
  background-color: var(--ids-button-destructive-tertiary-color-background-disabled);
  border-color: var(--ids-button-destructive-tertiary-color-border-disabled);
}
.ids-icon-button.btn-primary {
  background-color: var(--ids-button-primary-color-background-default);
  border-color: var(--ids-button-primary-color-border-default);
  border: 1px solid var(--ids-button-primary-color-border-default);
  color: var(--ids-button-primary-color-text-default);
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
}
.ids-icon-button.btn-primary:not(.hide-focus).is-active, .ids-icon-button.btn-primary:not(.hide-focus).is-focused, .ids-icon-button.btn-primary:not(.hide-focus).focus-within, .ids-icon-button.btn-primary:not(.hide-focus):focus {
  border-color: var(--ids-button-primary-color-border-focus);
}
.ids-icon-button.btn-primary:hover {
  background-color: var(--ids-button-primary-color-background-hover);
  border-color: var(--ids-button-primary-color-border-hover);
}
.ids-icon-button.btn-primary[disabled] {
  background-color: var(--ids-button-primary-color-background-disabled);
  border-color: var(--ids-button-primary-color-border-disabled);
  color: var(--ids-button-primary-color-text-disabled);
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-icon-button.btn-primary:active:not([disabled]) {
  background-color: var(--ids-button-primary-color-background-pressed);
  border-color: var(--ids-button-primary-color-border-pressed);
  color: var(--ids-button-primary-color-text-pressed);
}
.ids-icon-button.btn-primary-destructive {
  background-color: var(--ids-button-destructive-color-background-default);
  border-color: var(--ids-button-destructive-color-border-default);
  color: var(--ids-button-destructive-color-text-default);
}
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-icon-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-icon-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-icon-button.btn-primary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-color-border-focus);
}
.ids-icon-button.btn-primary-destructive:hover {
  background-color: var(--ids-button-destructive-color-background-hover);
  border-color: var(--ids-button-destructive-color-border-hover);
  color: var(--ids-button-destructive-color-text-hover);
}
.ids-icon-button.btn-primary-destructive[disabled] {
  background-color: var(--ids-button-destructive-color-background-disabled);
  border-color: var(--ids-button-destructive-color-border-disabled);
  color: var(--ids-button-destructive-color-text-disabled);
  opacity: var(--ids-button-destructive-opacity-disabled);
}
@keyframes dot-flashing {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-2);
  }
}
@keyframes dot-flashing-colors-secondary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-2);
  }
}
@keyframes dot-flashing-colors-tertiary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-2);
  }
}
.ids-icon-button .loading-dots-start {
  padding-inline-start: 3px !important;
  padding-inline-end: 7px !important;
  gap: 2px;
}
.ids-icon-button .loading-dots {
  display: none;
  position: relative;
  flex-direction: row;
  gap: 2px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
}
.ids-icon-button .loading-dots .dot {
  display: inline-flex;
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: var(--ids-button-ai-color-loading-dot-default);
  color: var(--ids-button-ai-color-loading-dot-default);
}
.ids-icon-button.btn-primary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-primary-sparkle-icon-color-fill);
  background: border-box var(--ids-button-ai-color-background-default);
  border: none;
  color: var(--ids-button-ai-color-text-default);
  align-items: center;
  min-width: 34px;
  min-height: 34px;
}
.ids-icon-button.btn-primary-generative-ai.compact {
  min-width: var(--ids-button-compact-width);
  min-height: var(--ids-button-compact-width);
}
.ids-icon-button.btn-primary-generative-ai:hover {
  background: border-box var(--ids-button-ai-color-background-hover);
}
.ids-icon-button.btn-primary-generative-ai:active, .ids-icon-button.btn-primary-generative-ai.gen-ai-active {
  background: border-box var(--ids-button-ai-color-background-active);
  color: var(--ids-button-ai-color-text-active);
}
.ids-icon-button.btn-primary-generative-ai[disabled] {
  background: border-box var(--ids-button-ai-color-background-disabled);
}
.ids-icon-button.btn-primary-generative-ai.color-variant-alternate-formatter, .ids-icon-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover {
  color: var(--ids-color-white-100);
  min-height: var(--ids-button-formatter-size);
  min-width: 34px;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-secondary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-secondary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-secondary-color-background-default);
  border: 1px solid var(--ids-button-ai-secondary-color-border-default);
  color: var(--ids-button-ai-secondary-color-default);
  align-items: center;
}
.ids-icon-button.btn-secondary-generative-ai:hover:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-hover);
  color: var(--ids-button-ai-secondary-color-hover);
  border-color: var(--ids-button-ai-secondary-color-border-hover);
}
.ids-icon-button.btn-secondary-generative-ai:active:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-active);
  color: var(--ids-button-ai-secondary-color-active);
  border-color: var(--ids-button-ai-secondary-color-border-active);
}
.ids-icon-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);
}
.ids-icon-button.btn-secondary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-secondary-color-background-active);
}
.ids-icon-button.btn-secondary-generative-ai[disabled] {
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot {
  background-color: var(--ids-button-ai-color-loading-dot-secondary);
  color: var(--ids-button-ai-color-loading-dot-secondary);
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-secondary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-tertiary-generative-ai {
  --ids-button-tertiary-ai-shadow-focus: var(--ids-button-tertiary-shadow-focus);
  --ids-button-ai-color-icon-secondary-hover: var(--ids-color-action-stronger);
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-tertiary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-tertiary-color-background-default);
  background-clip: text;
  align-items: center;
  color: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-generative-ai:hover {
  background: var(--ids-button-ai-tertiary-color-background-hover);
}
.ids-icon-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-tertiary-color-text-default);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-generative-ai:active, .ids-icon-button.btn-tertiary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-tertiary-color-background-active);
}
.ids-icon-button.btn-tertiary-generative-ai[disabled] {
  background: var(--ids-button-tertiary-ai-color-background-disabled);
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-tertiary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-secondary {
  background-color: var(--ids-button-secondary-color-background-default);
  border-width: var(--ids-button-secondary-border-width);
  border-color: var(--ids-button-secondary-color-border-default);
  color: var(--ids-button-secondary-color-text-default);
}
.ids-icon-button.btn-secondary:not(.hide-focus).is-active, .ids-icon-button.btn-secondary:not(.hide-focus).is-focused, .ids-icon-button.btn-secondary:not(.hide-focus).focus-within, .ids-icon-button.btn-secondary:not(.hide-focus):focus {
  background-color: var(--ids-button-secondary-color-background-focus);
  border-color: var(--ids-button-secondary-color-border-focus);
}
.ids-icon-button.btn-secondary:hover:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-hover);
  border-color: var(--ids-button-secondary-color-border-hover);
  color: var(--ids-button-secondary-color-text-hover);
}
.ids-icon-button.btn-secondary[disabled] {
  background-color: var(--ids-button-secondary-color-background-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
  color: var(--ids-button-secondary-color-text-disabled);
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-icon-button.btn-secondary:active:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-pressed);
  border-color: var(--ids-button-secondary-color-border-pressed);
  color: var(--ids-button-secondary-color-text-pressed);
}
.ids-icon-button.color-variant-alternate:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.ids-icon-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover {
  background-color: var(--ids-search-field-header-color-icon-hover);
}
.ids-icon-button.color-variant-app-menu:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.ids-icon-button.color-variant-alternate, .ids-icon-button.color-variant-alternate-formatter {
  color: var(--ids-button-alternate-color-text-default);
  opacity: 0.8;
}
.ids-icon-button.color-variant-alternate:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate:not(.hide-focus):focus, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-button-formatter-color-border-focus);
  opacity: 1;
}
.ids-icon-button.color-variant-alternate:hover, .ids-icon-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-formatter-color-text-hover);
  opacity: 1;
}
.ids-icon-button.color-variant-alternate[disabled], .ids-icon-button.color-variant-alternate-formatter[disabled] {
  background-color: var(--ids-color-transparent);
  opacity: var(--ids-button-formatter-opacity-disabled);
}
.ids-icon-button.color-variant-alternate-formatter {
  background-color: var(--ids-button-formatter-color-background-default);
  border-color: var(--ids-button-formatter-color-border-default);
  color: var(--ids-button-formatter-color-text-default);
  height: var(--ids-button-formatter-size);
  min-width: var(--ids-button-formatter-size);
}
.ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-color-border-focus);
}
.ids-icon-button.color-variant-alternate-formatter[disabled] {
  color: var(--ids-button-formatter-color-text-disabled);
}
.ids-icon-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  color: var(--ids-button-formatter-color-text-hover);
}
.ids-icon-button.color-variant-alternate-formatter.is-active {
  color: var(--ids-button-formatter-color-active);
}
.ids-icon-button.color-variant-alternate-formatter.ids-menu-button.compact {
  padding: var(--ids-space-2xs);
  padding-inline: var(--ids-space-2xs);
}
.ids-icon-button.color-variant-alternate-formatter.ids-menu-button.compact.square {
  border-radius: var(--ids-border-radius-xs);
  width: 34px;
}
.ids-icon-button.color-variant-alternate-formatter[editor-action=sourcemode], .ids-icon-button.color-variant-alternate-formatter[editor-action=editormode] {
  --ids-button-icon-width: 54px;
}
.ids-icon-button.color-variant-module {
  border: 0;
  color: var(--ids-button-module-color-text-default);
}
.ids-icon-button.color-variant-module:not(.square) {
  border-radius: var(--ids-button-module-border-radius);
}
.ids-icon-button.color-variant-module:hover {
  background-color: var(--ids-button-module-color-background-hover);
  color: var(--ids-button-module-color-text-hover);
}
.ids-icon-button {
  padding-inline-start: var(--ids-button-icon-padding);
  padding-inline-end: var(--ids-button-icon-padding);
  padding-block-start: var(--ids-button-icon-padding);
  padding-block-end: var(--ids-button-icon-padding);
}
.ids-icon-button:not(.no-padding):not(.sub-tab-button) {
  padding-inline-start: var(--ids-button-icon-padding);
  padding-inline-end: var(--ids-button-icon-padding);
  padding-top: var(--ids-button-icon-padding);
  padding-bottom: var(--ids-button-icon-padding);
}
.ids-icon-button:not(.no-padding):not(.sub-tab-button):not(.ids-trigger-button), .ids-icon-button:not(.no-padding):not(.sub-tab-button):not(.compact) .ids-icon-button:not(.no-padding):not(.sub-tab-button):not(.ids-sub-tab-close-button) {
  height: var(--ids-button-icon-height);
  width: var(--ids-button-icon-width);
}
.ids-icon-button.sub-tab-button {
  padding: 0;
}
.ids-icon-button:not(.no-padding):not(.ids-trigger-button).compact {
  height: calc(var(--ids-button-icon-compact-height) + 10px);
  width: calc(var(--ids-button-icon-compact-width) + 8px);
}
.ids-icon-button.compact {
  padding-inline-start: calc(var(--ids-space-xs) + 1px);
}
.ids-icon-button.compact.gen-ai-active .loading-dots {
  padding-inline-start: 1px;
}
.ids-icon-button:not(.square) {
  border-radius: var(--ids-button-radius);
}
.ids-icon-button.square {
  border-radius: var(--ids-border-radius-none);
}
.ids-icon-button.square:hover ::slotted(ids-icon[icon=logo]) {
  opacity: 1;
}
.ids-icon-button .ids-icon:not(.dropdown-icon) {
  display: block;
  padding-inline-start: var(--ids-space-3xs);
  font-size: 0;
  padding-block-start: var(--ids-space-3xs);
}
.ids-icon-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-icon-button.no-margins {
  margin-inline-start: var(--ids-space-none);
  margin-inline-end: var(--ids-space-none);
}

:host([field-height]) .ids-menu-button.field-height-lg {
  height: var(--ids-button-menu-field-height-lg);
}
:host([field-height]) .ids-menu-button.field-height-md {
  height: var(--ids-button-menu-field-height-md);
}
:host([field-height]) .ids-menu-button.field-height-sm {
  height: var(--ids-button-menu-field-height-sm);
}
:host([field-height]) .ids-menu-button.field-height-xs {
  height: var(--ids-button-menu-field-height-xs);
}

.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]) {
  box-shadow: var(--ids-button-tertiary-shadow-focus);
}
.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus {
  box-shadow: var(--ids-box-shadow-inverse);
}
.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus {
  box-shadow: var(--ids-shadow-20);
}
.ids-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus):focus {
  box-shadow: var(--ids-button-destructive-tertiary-shadow-focus);
}
.ids-button.btn-primary:not(.hide-focus).is-active, .ids-button.btn-primary:not(.hide-focus).is-focused, .ids-button.btn-primary:not(.hide-focus).focus-within, .ids-button.btn-primary:not(.hide-focus):focus,
.ids-icon-button.btn-primary:not(.hide-focus).is-active,
.ids-icon-button.btn-primary:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary:not(.hide-focus):focus,
.ids-menu-button.btn-primary:not(.hide-focus).is-active,
.ids-menu-button.btn-primary:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary:not(.hide-focus):focus {
  box-shadow: var(--ids-button-primary-shadow-focus);
}
.ids-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus):focus,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus):focus {
  box-shadow: 0 0 0 2px var(--ids-color-primary-70), 0 0 0 3px var(--ids-color-text-on-primary);
}
.ids-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-destructive:not(.hide-focus):focus {
  box-shadow: 0 0 0 2px var(--ids-color-background-default), 0 0 0 3px var(--ids-color-error-default);
}
.ids-button.btn-secondary:not(.hide-focus).is-active, .ids-button.btn-secondary:not(.hide-focus).is-focused, .ids-button.btn-secondary:not(.hide-focus).focus-within, .ids-button.btn-secondary:not(.hide-focus):focus,
.ids-icon-button.btn-secondary:not(.hide-focus).is-active,
.ids-icon-button.btn-secondary:not(.hide-focus).is-focused,
.ids-icon-button.btn-secondary:not(.hide-focus).focus-within,
.ids-icon-button.btn-secondary:not(.hide-focus):focus,
.ids-menu-button.btn-secondary:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary:not(.hide-focus):focus {
  box-shadow: var(--ids-button-secondary-shadow-focus);
}
.ids-button.btn-primary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-primary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-primary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-primary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus):focus {
  box-shadow: var(--ids-button-ai-shadow-focus);
  border-color: var(--ids-color-transparent);
}
.ids-button.btn-tertiary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-tertiary-generative-ai:not(.hide-focus):focus, .ids-button.btn-secondary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-secondary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-secondary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-secondary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus):focus {
  box-shadow: var(--ids-button-tertiary-ai-shadow-focus);
  border-color: var(--ids-button-ai-color-icon-secondary-hover);
}

.ids-modal-button:not(.ids-modal-icon-button) {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  /* stylelint-disable-next-line no-duplicate-selectors */
}
.ids-modal-button:not(.ids-modal-icon-button), .ids-modal-button:not(.ids-modal-icon-button)::before, .ids-modal-button:not(.ids-modal-icon-button)::after {
  box-sizing: border-box;
}
.ids-modal-button:not(.ids-modal-icon-button) * {
  pointer-events: none;
}
.ids-modal-button:not(.ids-modal-icon-button) {
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
}
.ids-modal-button:not(.ids-modal-icon-button):focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-modal-button:not(.ids-modal-icon-button):not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-modal-button:not(.ids-modal-icon-button) span {
  vertical-align: bottom;
}
.ids-modal-button:not(.ids-modal-icon-button) span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-modal-button:not(.ids-modal-icon-button):not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-modal-button:not(.ids-modal-icon-button) .ids-icon {
  vertical-align: middle;
}
.ids-modal-button:not(.ids-modal-icon-button).align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-modal-button:not(.ids-modal-icon-button).content-align-start {
  justify-content: start;
}
.ids-modal-button:not(.ids-modal-icon-button).content-align-end {
  justify-content: end;
}
.ids-modal-button:not(.ids-modal-icon-button).no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-modal-button:not(.ids-modal-icon-button).field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-modal-button:not(.ids-modal-icon-button) ::slotted(span) {
  font-weight: inherit !important;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary {
  background-color: var(--ids-modal-color-background);
  color: var(--ids-modal-button-color-default);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus):focus {
  outline: 1px solid var(--ids-modal-color-outline);
  outline-offset: -1px;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary:hover:not([disabled]) {
  color: var(--ids-modal-button-color-hover);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary[disabled] {
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary {
  background-color: var(--ids-modal-color-background);
  color: var(--ids-modal-button-secondary-color-default);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus):focus, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus):focus {
  outline: 1px solid var(--ids-modal-color-outline);
  outline-offset: -1px;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary:hover, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:hover {
  color: var(--ids-modal-button-secondary-color-hover);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary[disabled], .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary[disabled] {
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-modal-button:not(.ids-modal-icon-button) {
  padding-block-start: var(--ids-space-12);
  padding-block-end: var(--ids-space-12);
  display: block;
  font-weight: var(--ids-font-weight-strong);
  justify-content: center;
  height: 100%;
  width: 100%;
}
.ids-modal-button:not(.ids-modal-icon-button):focus {
  z-index: 1;
}

.ids-modal-icon-button {
  padding: var(--ids-space-xs);
}

.btn-swipe-action-left,
.btn-swipe-action-right {
  display: block;
  padding: 0 var(--ids-space-xs) var(--ids-space-xs);
  height: 100%;
  margin: 0;
  white-space: inherit;
  width: 85px;
}
.btn-swipe-action-left ::slotted(ids-icon),
.btn-swipe-action-right ::slotted(ids-icon) {
  display: block;
}
.btn-swipe-action-left:hover, .btn-swipe-action-left:focus,
.btn-swipe-action-right:hover,
.btn-swipe-action-right:focus {
  box-shadow: none;
  border-color: var(--ids-color-transparent);
}

.ids-button:not(.no-margins).btn-swipe-action-left,
.ids-button:not(.no-margins).btn-swipe-action-right {
  margin: 0;
}

.btn-swipe-action-left {
  border-start-end-radius: var(--ids-border-radius-none);
  border-end-end-radius: var(--ids-border-radius-none);
  background-color: var(--ids-swipe-action-color-background-left);
  color: var(--ids-swipe-action-color-text-left);
}
.btn-swipe-action-left:active {
  background-color: var(--ids-swipe-action-color-background-left-active);
  color: var(--ids-swipe-action-color-text-left-active);
}
.btn-swipe-action-left:hover {
  background-color: var(--ids-swipe-action-color-background-left-hover);
  color: var(--ids-swipe-action-color-text-left-hover);
}

.btn-swipe-action-right {
  border-start-start-radius: var(--ids-border-radius-none);
  border-end-start-radius: var(--ids-border-radius-none);
  background-color: var(--ids-swipe-action-color-background-right);
  color: var(--ids-swipe-action-color-text-right);
}
.btn-swipe-action-right:active {
  background-color: var(--ids-swipe-action-color-background-right-active);
  color: var(--ids-swipe-action-color-text-right-active);
}
.btn-swipe-action-right:hover {
  background-color: var(--ids-swipe-action-color-background-right-hover);
  color: var(--ids-swipe-action-color-text-right-hover);
}

.ids-icon-button.gen-ai-active:not(.no-animation) ::slotted(ids-icon[icon=genai]),
.ids-button.gen-ai-active:not(.no-animation) ::slotted(ids-icon[icon=genai]) {
  display: none;
}
.ids-icon-button.gen-ai-active:not(.no-animation) .loading-dots,
.ids-button.gen-ai-active:not(.no-animation) .loading-dots {
  display: flex;
}

.ids-icon-button.gen-ai-active .loading-dots {
  padding-inline-start: 3px;
  padding-inline-end: var(--ids-space-3xs);
  padding-block-start: 7px;
  padding-block-end: var(--ids-space-xs);
}

.ids-button ::slotted(ids-icon[icon=genai]:first-child),
.ids-toggle-button ::slotted(ids-icon[icon=genai]:first-child),
.ids-menu-button:not(.ids-icon-button) ::slotted(ids-icon[icon=genai]:first-child),
.ids-modal-button:not(.ids-icon-button) ::slotted(ids-icon[icon=genai]:first-child) {
  margin-inline-end: 5px;
}
.ids-button ::slotted(ids-icon:not(:first-child)),
.ids-toggle-button ::slotted(ids-icon:not(:first-child)),
.ids-menu-button:not(.ids-icon-button) ::slotted(ids-icon:not(:first-child)),
.ids-modal-button:not(.ids-icon-button) ::slotted(ids-icon:not(:first-child)) {
  margin-inline-start: 5px;
  margin-inline-end: var(--ids-space-none);
}
.ids-button .ids-icon:last-child,
.ids-button span + span:not(.audible),
.ids-button span:not(.audible):last-child,
.ids-toggle-button .ids-icon:last-child,
.ids-toggle-button span + span:not(.audible),
.ids-toggle-button span:not(.audible):last-child,
.ids-menu-button:not(.ids-icon-button) .ids-icon:last-child,
.ids-menu-button:not(.ids-icon-button) span + span:not(.audible),
.ids-menu-button:not(.ids-icon-button) span:not(.audible):last-child,
.ids-modal-button:not(.ids-icon-button) .ids-icon:last-child,
.ids-modal-button:not(.ids-icon-button) span + span:not(.audible),
.ids-modal-button:not(.ids-icon-button) span:not(.audible):last-child {
  padding-inline-start: 5px;
}

.ids-modal-button ::slotted(ids-icon:not(:first-child)) {
  padding: var(--ids-space-3xs);
}

:host(:not([show-loading-indicator=true])) ::slotted(.slot-loading-indicator) {
  display: none;
}

:host([show-loading-indicator=true]) ::slotted(ids-loading-indicator) {
  margin-top: 3px;
  margin-bottom: 3px;
}

:host([show-loading-indicator=true][loading-indicator-only=true]) ::slotted(*:not(.slot-loading-indicator)) {
  visibility: hidden;
}

:host([show-loading-indicator=true]:not([loading-indicator-only=true])) ::slotted(.slot-loading-indicator) {
  margin-inline-start: 6px;
}

:host([show-loading-indicator=true]:not([loading-indicator-only=true]):is([appearance=primary], [appearance=secondary], [appearance=primary-destructive]))::part(button) {
  padding-inline-start: 20px;
  padding-inline-end: 12px;
}
:host([show-loading-indicator=true]:not([loading-indicator-only=true]):is([appearance=primary], [appearance=secondary], [appearance=primary-destructive])) ::slotted(.slot-loading-indicator) {
  margin-inline-start: 10px;
}

:host([loading-indicator-only=true]) ::slotted(.slot-loading-indicator) {
  position: absolute;
  margin-inline-start: auto;
  margin-inline-end: auto;
  left: var(--ids-space-none);
  right: var(--ids-space-none);
}

:host(ids-toggle-button:not(.dropdown-btn)) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-default);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-default);
}

:host(ids-toggle-button[pressed]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-default);
}

:host(ids-toggle-button[color=orange]) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-orange);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-orange);
}

:host(ids-toggle-button[pressed][color=orange]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-orange);
}

:host(ids-toggle-button[color=red]) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-red);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-red);
}

:host(ids-toggle-button[pressed][color=red]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-red);
}

:host(ids-toggle-button.ids-toggle-button-segmented) button {
  border-radius: var(--ids-border-radius-sm);
  font-weight: var(--ids-font-weight-normal);
}
:host(ids-toggle-button.ids-toggle-button-segmented) button:hover {
  color: var(--ids-segmented-control-text-color);
  background-color: var(--ids-segmented-control-background-hover);
}

:host(ids-toggle-button.ids-toggle-button-segmented[pressed]) button {
  color: var(--ids-segmented-control-text-color);
  background-color: var(--ids-segmented-control-background-selected);
  box-shadow: var(--ids-segmented-control-box-shadow);
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-button/ids-button.scss","webpack://./src/components/ids-button/ids-button-base.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA;;;EAAA;ACAA;;EAAA;AAiIA;;EAAA;AAWA;;EAAA;AA2fA;;EAAA;ADhoBA;EACE,oBAAA;EACA,sBAAA;AAUF;AARE;EACE,sBAAA;AAUJ;AAPE;;EAEE,mBAAA;EACA,kBAAA;AASJ;AANE;EACE,sBAAA;EACA,mBAAA;AAQJ;AALE;EACE,uCAAA;AAOJ;AAJE;EEPA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AFcF;AATE;;EAEE,uBAAA;EACA,YAAA;EACA,WAAA;AAWJ;;AAPA;EACE,aAAA;AAUF;;AANE;EACE,8CAAA;EACA,0CAAA;EACA,gDAAA;AASJ;;AALA;EACE,aAAA;AAQF;;AAJA;EACE,cAAA;AAOF;;AADA;;;;EEzDE,mCAAA;EACA,kCAAA;AFiEF;AAHE;;;;EACE,oBAAA;EACA,kBAAA;EACA,sBAAA;AAQJ;;AAFE;;EACE,mCAAA;EACA,uCAAA;EACA,iBAAA;AAMJ;;AADE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAIJ;;AAAA;;;EC9FE,kCAAA;EAwBA,0CAAA;EACA,+EAAA;EACA,kCAAA;EACA,gBAAA;EACA,+CAAA;EACA,4CAAA;EACA,kBAAA;AD6EF;AC3EE;;;;;;;EAGE,sBAAA;ADiFJ;AC7EE;;;EACE,oBAAA;ADiFJ;AC3EE;;;EACE,6BAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kQACE;EAIF,mBAAA;ADyEJ;ACtEE;;;EAEE,aAAA;EACA,2CAAA;ADyEJ;ACtEE;;;EACC,iCAAA;AD0EH;ACrEE;;;EACE,sBAAA;ADyEJ;ACvEI;;;EC3DF,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AFuIF;AC9EE;;;EACE,mDAAA;ADkFJ;AC/EE;;;EACE,sBAAA;ADmFJ;AC5EI;;;EACE,yCAAA;ADgFN;AC5EE;;;EACE,sBAAA;ADgFJ;AC7EE;;;EACE,oBAAA;ADiFJ;AC9EE;;;EACE,oCAAA;ADkFJ;AC/EE;;;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ADmFJ;AChFE;;;EAEE,+BAAA;ADmFJ;AChEE;;;EACE,oBAAA;EACA,mDAAA;EACA,uCAAA;EAIA,qEAAA;EACA,6DAAA;EACA,oDAAA;ADiEJ;AC1DI;;;;;;;;;EACE,2DAAA;ADoEN;AChEE;;;EACE,kDAAA;EACA,mEAAA;EACA,2DAAA;ADoEJ;ACjEE;;;EACE,qDAAA;EACA,sEAAA;EACA,8DAAA;EACA,oDAAA;ADqEJ;AClEE;;;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;ADsEJ;ACjEE;;;EACE,iFAAA;EACA,yEAAA;EACA,gEAAA;ADqEJ;ACnEI;;;;;;;;;EAIE,uEAAA;AD0EN;ACvEI;;;EACE,+EAAA;EACA,uEAAA;EACA,8DAAA;AD2EN;ACxEI;;;EACE,iEAAA;EACA,kFAAA;EACA,0EAAA;AD4EN;ACrEE;;;EACE,oEAAA;EACA,4DAAA;EACA,gEAAA;EACA,mDAAA;EACA,+CAAA;EACA,4CAAA;ADyEJ;ACvEI;;;;;;;;;EAIE,0DAAA;AD8EN;AC3EI;;;EACE,kEAAA;EACA,0DAAA;AD+EN;AC5EI;;;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;EACA,mDAAA;ADgFN;AC7EI;;;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ADiFN;AC1EE;;;EACE,wEAAA;EACA,gEAAA;EACA,uDAAA;AD8EJ;AC5EI;;;;;;;;;EAIE,8DAAA;ADmFN;AChFI;;;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ADoFN;ACjFI;;;EACE,yEAAA;EACA,iEAAA;EACA,wDAAA;EACA,uDAAA;ADqFN;AC/EE;EACE;IACE,uEAAA;EDiFJ;EC9EE;IAEI,uEAAA;ED+EN;AACF;AC5EE;EACE;IACE,yEAAA;ED8EJ;EC3EE;IAEI,yEAAA;ED4EN;AACF;ACzEE;EACE;IACE,wEAAA;ED2EJ;ECxEE;IAEI,wEAAA;EDyEN;AACF;ACtEE;;;EACE,oCAAA;EACA,kCAAA;EACA,QAAA;AD0EJ;ACvEE;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,uBAAA;AD2EJ;ACzEI;;;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gEAAA;EACA,qDAAA;AD6EN;ACzEE;;;EACE,6FAAA;EAEA,oEAAA;EACA,YAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AD4EJ;AC1EI;;;EACE,0CAAA;EACA,2CAAA;AD8EN;AC3EI;;;EACE,kEAAA;AD+EN;AC5EI;;;;;EAEE,mEAAA;EACA,6CAAA;ADiFN;AC9EI;;;EACE,qEAAA;ADkFN;AC/EI;;;;;EAEE,iCAAA;EACA,4CAAA;EACA,eAAA;ADoFN;AChFM;;;EACE,6CAAA;EACA,mBAAA;ADoFR;ACjFM;;;EACE,oDAAA;EACA,qBAAA;ADqFR;AClFM;;;EACE,6CAAA;EACA,mBAAA;ADsFR;AC/EE;;;EACE,+FAAA;EAEA,mEAAA;EACA,qEAAA;EACA,mDAAA;EACA,mBAAA;ADkFJ;AChFI;;;EACE,iEAAA;EACA,iDAAA;EACA,+DAAA;ADoFN;ACjFI;;;EACE,kEAAA;EACA,kDAAA;EACA,gEAAA;ADqFN;AClFI;;;EACE,iFAAA;EACA,qFAAA;ADsFN;ACnFI;;;EACE,kEAAA;ADuFN;ACpFI;;;EACE,8CAAA;ADwFN;ACnFM;;;EACE,kEAAA;EACA,uDAAA;ADuFR;ACpFM;;;EACE,8DAAA;EACA,mBAAA;ADwFR;ACrFM;;;EACE,qEAAA;EACA,qBAAA;ADyFR;ACtFM;;;EACE,8DAAA;EACA,mBAAA;AD0FR;ACnFE;;;EACE,8EAAA;EACA,4EAAA;EACA,8FAAA;EAEA,kEAAA;EACA,qBAAA;EACA,mBAAA;EACA,uDAAA;ADsFJ;ACpFI;;;EACE,gEAAA;ADwFN;ACrFI;;;EACE,oFAAA;EACA,sFAAA;ADyFN;ACtFI;;;;;EAEE,iEAAA;AD2FN;ACxFI;;;EACE,mEAAA;EACA,8CAAA;AD4FN;ACvFM;;;EACE,6DAAA;EACA,mBAAA;AD2FR;ACxFM;;;EACE,oEAAA;EACA,qBAAA;AD4FR;ACzFM;;;EACE,6DAAA;EACA,mBAAA;AD6FR;ACtFE;;;EACE,sEAAA;EACA,sDAAA;EACA,8DAAA;EACA,qDAAA;AD0FJ;ACxFI;;;;;;;;;EAIE,oEAAA;EACA,4DAAA;AD+FN;AC5FI;;;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ADgGN;AC7FI;;;EACE,uEAAA;EACA,+DAAA;EACA,sDAAA;EACA,qDAAA;ADiGN;AC9FI;;;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ADkGN;ACxFI;;;EACE,oCAAA;AD4FN;ACxFM;;;EACE,iEAAA;AD4FR;ACrFI;;;EACE,2CAAA;ADyFN;ACpFE;;;;;EAEE,qDAAA;EACA,YAAA;ADyFJ;ACvFI;;;;;;;;;;;;;;;;;EAIE,4DAAA;EACA,UAAA;ADsGN;ACnGI;;;;;EACE,oEAAA;EACA,0CAAA;EACA,mDAAA;EACA,UAAA;ADyGN;ACtGI;;;;;EACE,8CAAA;EACA,qDAAA;AD4GN;ACvGE;;;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;EACA,wCAAA;EACA,2CAAA;AD2GJ;ACzGI;;;;;;;;;EAIE,2CAAA;ADgHN;AC7GI;;;EACE,sDAAA;ADiHN;AC9GI;;;EACE,oEAAA;EACA,mDAAA;ADkHN;AC/GI;;;EACE,+CAAA;ADmHN;AChHI;;;EACE,6BAAA;EACA,oCAAA;ADoHN;AClHM;;;EACE,0CAAA;EACA,WAAA;ADsHR;AClHI;;;;;EAEE,6BAAA;ADuHN;AClHE;;;EACE,SAAA;EACA,kDAAA;ADsHJ;ACpHI;;;EACE,qDAAA;ADwHN;ACrHI;;;EACE,iEAAA;EACA,gDAAA;ADyHN;AA9oBE;;;ECwBA,gDAAA;AD2nBF;AA/oBE;;;;;ECwBA,mCAAA;AD8nBF;AAjpBE;;;ECmBA,mCAAA;ADmoBF;;AAjpBA;EACE,uBAAA;AAopBF;;AAjpBA;;EAEE,gEAAA;EACA,+CAAA;AAopBF;;AAhpBE;EACE,qDAAA;EACA,mDAAA;AAmpBJ;AAhpBE;EACE,uBAAA;AAkpBJ;AAhpBI;EACE,kBAAA;EACA,sCAAA;AAkpBN;;AA5oBA;EACE,YAAA;EACA,YAAA;AA+oBF;;AA5oBA;ECpJE,kCAAA;EAwBA,0CAAA;EACA,+EAAA;EACA,kCAAA;EACA,gBAAA;EACA,+CAAA;EACA,4CAAA;EACA,kBAAA;ED2HA,uDAAA;AAmpBF;AC5wBE;EAGE,sBAAA;AD4wBJ;ACxwBE;EACE,oBAAA;AD0wBJ;ACpwBE;EACE,6BAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kQACE;EAIF,mBAAA;ADgwBJ;AC7vBE;EAEE,aAAA;EACA,2CAAA;AD8vBJ;AC3vBE;EACC,iCAAA;AD6vBH;ACxvBE;EACE,sBAAA;AD0vBJ;ACxvBI;EC3DF,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AFszBF;AC7vBE;EACE,mDAAA;AD+vBJ;AC5vBE;EACE,sBAAA;AD8vBJ;ACvvBI;EACE,yCAAA;ADyvBN;ACrvBE;EACE,sBAAA;ADuvBJ;ACpvBE;EACE,oBAAA;ADsvBJ;ACnvBE;EACE,oCAAA;ADqvBJ;AClvBE;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ADovBJ;ACjvBE;EAEE,+BAAA;ADkvBJ;AC/tBE;EACE,oBAAA;EACA,mDAAA;EACA,uCAAA;EAIA,qEAAA;EACA,6DAAA;EACA,oDAAA;AD8tBJ;ACvtBI;EACE,2DAAA;ADytBN;ACrtBE;EACE,kDAAA;EACA,mEAAA;EACA,2DAAA;ADutBJ;ACptBE;EACE,qDAAA;EACA,sEAAA;EACA,8DAAA;EACA,oDAAA;ADstBJ;ACntBE;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;ADqtBJ;AChtBE;EACE,iFAAA;EACA,yEAAA;EACA,gEAAA;ADktBJ;AChtBI;EAIE,uEAAA;AD+sBN;AC5sBI;EACE,+EAAA;EACA,uEAAA;EACA,8DAAA;AD8sBN;AC3sBI;EACE,iEAAA;EACA,kFAAA;EACA,0EAAA;AD6sBN;ACtsBE;EACE,oEAAA;EACA,4DAAA;EACA,gEAAA;EACA,mDAAA;EACA,+CAAA;EACA,4CAAA;ADwsBJ;ACtsBI;EAIE,0DAAA;ADqsBN;AClsBI;EACE,kEAAA;EACA,0DAAA;ADosBN;ACjsBI;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;EACA,mDAAA;ADmsBN;AChsBI;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ADksBN;AC3rBE;EACE,wEAAA;EACA,gEAAA;EACA,uDAAA;AD6rBJ;AC3rBI;EAIE,8DAAA;AD0rBN;ACvrBI;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ADyrBN;ACtrBI;EACE,yEAAA;EACA,iEAAA;EACA,wDAAA;EACA,uDAAA;ADwrBN;AClrBE;EACE;IACE,uEAAA;EDorBJ;ECjrBE;IAEI,uEAAA;EDkrBN;AACF;AC/qBE;EACE;IACE,yEAAA;EDirBJ;EC9qBE;IAEI,yEAAA;ED+qBN;AACF;AC5qBE;EACE;IACE,wEAAA;ED8qBJ;EC3qBE;IAEI,wEAAA;ED4qBN;AACF;ACzqBE;EACE,oCAAA;EACA,kCAAA;EACA,QAAA;AD2qBJ;ACxqBE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,uBAAA;AD0qBJ;ACxqBI;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gEAAA;EACA,qDAAA;AD0qBN;ACtqBE;EACE,6FAAA;EAEA,oEAAA;EACA,YAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ADuqBJ;ACrqBI;EACE,0CAAA;EACA,2CAAA;ADuqBN;ACpqBI;EACE,kEAAA;ADsqBN;ACnqBI;EAEE,mEAAA;EACA,6CAAA;ADoqBN;ACjqBI;EACE,qEAAA;ADmqBN;AChqBI;EAEE,iCAAA;EACA,4CAAA;EACA,eAAA;ADiqBN;AC7pBM;EACE,6CAAA;EACA,mBAAA;AD+pBR;AC5pBM;EACE,oDAAA;EACA,qBAAA;AD8pBR;AC3pBM;EACE,6CAAA;EACA,mBAAA;AD6pBR;ACtpBE;EACE,+FAAA;EAEA,mEAAA;EACA,qEAAA;EACA,mDAAA;EACA,mBAAA;ADupBJ;ACrpBI;EACE,iEAAA;EACA,iDAAA;EACA,+DAAA;ADupBN;ACppBI;EACE,kEAAA;EACA,kDAAA;EACA,gEAAA;ADspBN;ACnpBI;EACE,iFAAA;EACA,qFAAA;ADqpBN;AClpBI;EACE,kEAAA;ADopBN;ACjpBI;EACE,8CAAA;ADmpBN;AC9oBM;EACE,kEAAA;EACA,uDAAA;ADgpBR;AC7oBM;EACE,8DAAA;EACA,mBAAA;AD+oBR;AC5oBM;EACE,qEAAA;EACA,qBAAA;AD8oBR;AC3oBM;EACE,8DAAA;EACA,mBAAA;AD6oBR;ACtoBE;EACE,8EAAA;EACA,4EAAA;EACA,8FAAA;EAEA,kEAAA;EACA,qBAAA;EACA,mBAAA;EACA,uDAAA;ADuoBJ;ACroBI;EACE,gEAAA;ADuoBN;ACpoBI;EACE,oFAAA;EACA,sFAAA;ADsoBN;ACnoBI;EAEE,iEAAA;ADooBN;ACjoBI;EACE,mEAAA;EACA,8CAAA;ADmoBN;AC9nBM;EACE,6DAAA;EACA,mBAAA;ADgoBR;AC7nBM;EACE,oEAAA;EACA,qBAAA;AD+nBR;AC5nBM;EACE,6DAAA;EACA,mBAAA;AD8nBR;ACvnBE;EACE,sEAAA;EACA,sDAAA;EACA,8DAAA;EACA,qDAAA;ADynBJ;ACvnBI;EAIE,oEAAA;EACA,4DAAA;ADsnBN;ACnnBI;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ADqnBN;AClnBI;EACE,uEAAA;EACA,+DAAA;EACA,sDAAA;EACA,qDAAA;ADonBN;ACjnBI;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ADmnBN;ACzmBI;EACE,oCAAA;AD2mBN;ACvmBM;EACE,iEAAA;ADymBR;AClmBI;EACE,2CAAA;ADomBN;AC/lBE;EAEE,qDAAA;EACA,YAAA;ADgmBJ;AC9lBI;EAIE,4DAAA;EACA,UAAA;AD6lBN;AC1lBI;EACE,oEAAA;EACA,0CAAA;EACA,mDAAA;EACA,UAAA;AD4lBN;ACzlBI;EACE,8CAAA;EACA,qDAAA;AD2lBN;ACtlBE;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;EACA,wCAAA;EACA,2CAAA;ADwlBJ;ACtlBI;EAIE,2CAAA;ADqlBN;ACllBI;EACE,sDAAA;ADolBN;ACjlBI;EACE,oEAAA;EACA,mDAAA;ADmlBN;AChlBI;EACE,+CAAA;ADklBN;AC/kBI;EACE,6BAAA;EACA,oCAAA;ADilBN;AC/kBM;EACE,0CAAA;EACA,WAAA;ADilBR;AC7kBI;EAEE,6BAAA;AD8kBN;ACzkBE;EACE,SAAA;EACA,kDAAA;AD2kBJ;ACzkBI;EACE,qDAAA;AD2kBN;ACxkBI;EACE,iEAAA;EACA,gDAAA;AD0kBN;AA3iCE;EACE,oDAAA;EACA,kDAAA;EACA,mDAAA;EACA,iDAAA;AA6iCJ;AA1iCE;EACE,oDAAA;EACA,kDAAA;EACA,2CAAA;EACA,8CAAA;AA4iCJ;AA1iCI;EAGE,qCAAA;EACA,mCAAA;AA0iCN;AAtiCE;EACE,UAAA;AAwiCJ;AApiCI;EACE,0DAAA;EACA,uDAAA;AAsiCN;AAliCE;EACE,qDAAA;AAoiCJ;AAliCI;EACE,yBAAA;AAoiCN;AAhiCE;EACE,uCAAA;AAkiCJ;AA/hCE;EACE,4CAAA;AAiiCJ;AA9hCM;EACE,UAAA;AAgiCR;AA3hCE;EACE,cAAA;EACA,0CAAA;EACA,YAAA;EACA,yCAAA;AA6hCJ;AA1hCE;EEvMA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AFouCF;AAhiCE;EACE,0CAAA;EACA,wCAAA;AAkiCJ;;AA5hCI;EACE,8CAAA;AA+hCN;AA5hCI;EACE,8CAAA;AA8hCN;AA3hCI;EACE,8CAAA;AA6hCN;AA1hCI;EACE,8CAAA;AA4hCN;;ACjoBM;;;;;;;;;EACE,mDAAA;AD4oBR;ACvoBM;;;;;;;;;EAIE,yCAAA;AD8oBR;ACzoBM;;;;;;;;;EAIE,gCAAA;ADgpBR;AC1oBI;;;;;;;;;EAIE,+DAAA;ADipBN;AC1oBI;;;;;;;;;EAIE,kDAAA;ADipBN;AC7oBM;;;;;;;;;EAlrBJ,6FACE;ADy0CJ;ACzoBI;;;;;;;;;EAjsBF,mGACE;ADo1CJ;ACtoBI;;;;;;;;;EAIE,oDAAA;AD6oBN;ACxoBI;;;;;;;;;EAIE,6CAAA;EACA,0CAAA;AD+oBN;ACzoBI;;;;;;;;;;;;;;;;;EAIE,sDAAA;EACA,6DAAA;ADwpBN;;AAvoCA;EC9PE,kCAAA;EAwBA,0CAAA;EACA,+EAAA;EACA,kCAAA;EACA,gBAAA;EACA,+CAAA;EACA,4CAAA;EACA,kBAAA;EDoOA,uDAAA;AA+oCF;ACj3CE;EAGE,sBAAA;ADi3CJ;AC72CE;EACE,oBAAA;AD+2CJ;ACz2CE;EACE,6BAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kQACE;EAIF,mBAAA;ADq2CJ;ACl2CE;EAEE,aAAA;EACA,2CAAA;ADm2CJ;ACh2CE;EACC,iCAAA;ADk2CH;AC71CE;EACE,sBAAA;AD+1CJ;AC71CI;EC3DF,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AF25CF;ACl2CE;EACE,mDAAA;ADo2CJ;ACj2CE;EACE,sBAAA;ADm2CJ;AC51CI;EACE,yCAAA;AD81CN;AC11CE;EACE,sBAAA;AD41CJ;ACz1CE;EACE,oBAAA;AD21CJ;ACx1CE;EACE,oCAAA;AD01CJ;ACv1CE;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ADy1CJ;ACt1CE;EAEE,+BAAA;ADu1CJ;ACxtBE;EACE,mDAAA;EACA,4CAAA;AD0tBJ;ACxtBI;EA7uBF,iDAAA;EACA,oBAAA;ADw8CF;ACrtBI;EACE,0CAAA;ADutBN;ACptBI;EACE,mDAAA;ADstBN;AC/sBE;EAEE,mDAAA;EACA,sDAAA;ADgtBJ;AC9sBI;EArwBF,iDAAA;EACA,oBAAA;ADs9CF;AC3sBI;EACE,oDAAA;AD6sBN;AC1sBI;EACE,qDAAA;AD4sBN;AAtuCE;EACE,wCAAA;EACA,sCAAA;EACA,cAAA;EACA,0CAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAwuCJ;AAruCE;EACE,UAAA;AAuuCJ;;AAluCA;EACE,4BAAA;AAquCF;;AAhuCA;;EAEE,cAAA;EACA,kDAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;AAmuCF;AAjuCE;;EACE,cAAA;AAouCJ;AAjuCE;;;EAEE,gBAAA;EACA,0CAAA;AAouCJ;;AA/tCA;;EAEE,SAAA;AAkuCF;;AA/tCA;EACE,sDAAA;EACA,oDAAA;EACA,+DAAA;EACA,8CAAA;AAkuCF;AAhuCE;EACE,sEAAA;EACA,qDAAA;AAkuCJ;AA/tCE;EACE,qEAAA;EACA,oDAAA;AAiuCJ;;AA7tCA;EACE,wDAAA;EACA,sDAAA;EACA,gEAAA;EACA,+CAAA;AAguCF;AA9tCE;EACE,uEAAA;EACA,sDAAA;AAguCJ;AA7tCE;EACE,sEAAA;EACA,qDAAA;AA+tCJ;;AAxtCI;;EACE,aAAA;AA4tCN;AAztCI;;EACE,aAAA;AA4tCN;;AAvtCA;EACE,yBAAA;EACA,wCAAA;EACA,wBAAA;EACA,sCAAA;AA0tCF;;AAltCE;;;;EACE,sBAAA;AAwtCJ;AAptCE;;;;EACE,wBAAA;EACA,wCAAA;AAytCJ;AArtCE;;;;;;;;;;;;EAGE,yBAAA;AAguCJ;;AA1tCE;EACE,6BAAA;AA6tCJ;;AAvtCE;EACE,aAAA;AA0tCJ;;AArtCE;EACE,eAAA;EACA,kBAAA;AAwtCJ;;AAntCE;EACE,kBAAA;AAstCJ;;AAjtCE;EACE,wBAAA;AAotCJ;;AA/sCE;EACE,0BAAA;EACA,wBAAA;AAktCJ;AA/sCE;EACE,yBAAA;AAitCJ;;AA5sCE;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;AA+sCJ;;AA1sCA;EACE,qGAAA;EACA,yFAAA;AA6sCF;;AA1sCA;EACE,6FAAA;AA6sCF;;AA1sCA;EACE,oGAAA;EACA,wFAAA;AA6sCF;;AA1sCA;EACE,4FAAA;AA6sCF;;AA1sCA;EACE,iGAAA;EACA,qFAAA;AA6sCF;;AA1sCA;EACE,yFAAA;AA6sCF;;AAzsCE;EACE,0CAAA;EACA,0CAAA;AA4sCJ;AA1sCI;EACE,8CAAA;EACA,+DAAA;AA4sCN;;AAtsCE;EACE,8CAAA;EACA,kEAAA;EACA,mDAAA;EACA,yBAAA;AAysCJ","sourcesContent":["/**\n * Ids Button Component CSS\n * (Includes standard and icon button rules)\n */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use './ids-button-base' as button;\n\n:host {\n  display: inline-flex;\n  vertical-align: middle;\n\n  ::slotted(span) {\n    vertical-align: bottom;\n  }\n\n  ::slotted(span),\n  ::slotted(ids-text) {\n    color: currentColor;\n    align-self: center;\n  }\n\n  ::slotted(ids-icon) {\n    vertical-align: middle;\n    color: currentColor;\n  }\n\n  ::slotted(ids-icon[compact='true']) {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  ::slotted(span.audible) {\n    @include mixins.audible();\n  }\n\n  // Button elements should fill the space inside shadow root\n  button,\n  .ids-icon-button {\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n  }\n}\n\n:host(.hidden) {\n  display: none;\n}\n\n:host([system-button]) {\n  button:not(.is-active):hover {\n    background-color: var(--ids-color-transparent);\n    border-color: var(--ids-color-transparent);\n    color: var(--ids-button-system-color-text-hover);\n  }\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n// Reset button display styles internally\nbutton {\n  display: block;\n}\n\n\n\n// Applies to all non-icon button types\n.ids-button,\n.ids-toggle-button,\n.ids-menu-button:not(.ids-icon-button),\n.ids-modal-button {\n  @include mixins.antialiased();\n\n  .ids-icon {\n    display: inline-flex;\n    place-self: center;\n    vertical-align: middle;\n  }\n}\n\n.ids-button,\n.ids-icon-button {\n  &.compact {\n    font-size: var(--ids-font-size-2xs);\n    height: var(--ids-button-compact-width);\n    line-height: 16px;\n  }\n}\n\n.ids-button.ellipsis {\n  ::slotted(span) {\n    display: block;\n    max-width: 100%;\n    overflow: hidden ;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: inherit;\n    height: inherit;\n  }\n}\n\n.ids-button,\n.ids-toggle-button,\n.ids-menu-button {\n  @include button.ids-base-button-styles();\n  @include button.ids-standard-button-colors();\n\n  // Assign padding based on type/usage\n  // ====================================================\n  &:not(.no-padding) {\n    @include button.ids-standard-button-padding();\n  }\n\n  &.btn-tertiary,\n  &.btn-tertiary-destructive {\n    @include button.ids-inline-button-padding();\n  }\n\n  &.no-padding {\n    @include button.ids-inline-button-padding();\n  }\n}\n\n.ids-menu-button.sub-tab-button.is-active {\n  background-color: unset;\n}\n\n.ids-menu-button.is-active,\n.ids-menu-button.is-active:hover {\n  background-color: var(--ids-button-menu-background-color-active);\n  color: var(--ids-button-menu-color-text-active);\n}\n\n.ids-menu-button.formatter-width {\n  &:not(.no-padding):not(.ids-icon-button) {\n    padding-inline-start: calc(var(--ids-space-xs) - 1px);\n    padding-inline-end: calc(var(--ids-space-xs) - 1px);\n  }\n\n  &:not(.formatter-width-percentage) {\n    justify-content: normal;\n\n    .ids-icon {\n      position: absolute;\n      inset-inline-end: var(--ids-space-2xs);\n    }\n  }\n}\n\n// Log button on masthead\n::slotted(ids-icon[icon='logo']) {\n  height: 30px;\n  opacity: 0.8;\n}\n\n.ids-icon-button {\n  @include button.ids-base-button-styles();\n  @include button.ids-standard-button-colors();\n\n  // Everything below is only for icon buttons\n  /* stylelint-disable-next-line no-duplicate-selectors */\n  & {\n    padding-inline-start: var(--ids-button-icon-padding);\n    padding-inline-end: var(--ids-button-icon-padding);\n    padding-block-start: var(--ids-button-icon-padding);\n    padding-block-end: var(--ids-button-icon-padding);\n  }\n\n  &:not(.no-padding):not(.sub-tab-button) {\n    padding-inline-start: var(--ids-button-icon-padding);\n    padding-inline-end:var(--ids-button-icon-padding);\n    padding-top: var(--ids-button-icon-padding);\n    padding-bottom: var(--ids-button-icon-padding);\n\n    &:not(.ids-trigger-button),\n    &:not(.compact)\n    &:not(.ids-sub-tab-close-button) {\n      height: var(--ids-button-icon-height);\n      width: var(--ids-button-icon-width);\n    }\n  }\n\n  &.sub-tab-button {\n    padding: 0;\n  }\n\n  &:not(.no-padding):not(.ids-trigger-button) {\n    &.compact {\n      height: calc(var(--ids-button-icon-compact-height) + 10px);\n      width: calc(var(--ids-button-icon-compact-width) + 8px);\n    }\n  }\n\n  &.compact {\n    padding-inline-start: calc(var(--ids-space-xs) + 1px);\n\n    &.gen-ai-active .loading-dots {\n      padding-inline-start: 1px;\n    }\n  }\n\n  &:not(.square) {\n    border-radius: var(--ids-button-radius);\n  }\n\n  &.square {\n    border-radius: var(--ids-border-radius-none);\n\n    &:hover {\n      ::slotted(ids-icon[icon='logo']) {\n        opacity: 1;\n      }\n    }\n  }\n\n  .ids-icon:not(.dropdown-icon) {\n    display: block;\n    padding-inline-start: var(--ids-space-3xs);\n    font-size: 0;\n    padding-block-start: var(--ids-space-3xs);\n  }\n\n  span.audible {\n    @include mixins.audible();\n  }\n\n  &.no-margins {\n    margin-inline-start: var(--ids-space-none);\n    margin-inline-end: var(--ids-space-none);\n  }\n}\n\n:host([field-height]) {\n  .ids-menu-button {\n    &.field-height-lg {\n      height: var(--ids-button-menu-field-height-lg);\n    }\n\n    &.field-height-md {\n      height: var(--ids-button-menu-field-height-md);\n    }\n\n    &.field-height-sm {\n      height: var(--ids-button-menu-field-height-sm);\n    }\n\n    &.field-height-xs {\n      height: var(--ids-button-menu-field-height-xs);\n    }\n  }\n}\n\n// Mix-in special rules for contextual buttons\n.ids-button,\n.ids-icon-button,\n.ids-menu-button {\n  @include button.ids-standard-button-shadows();\n}\n\n// Specific Modifications for Modal Buttons\n// Do not apply styles to modal close icon button, appearance as icon is required\n.ids-modal-button:not(.ids-modal-icon-button) {\n  @include button.ids-base-button-styles();\n  @include button.ids-modal-button-color-defaults();\n\n  /* stylelint-disable-next-line no-duplicate-selectors */\n  & {\n    padding-block-start: var(--ids-space-12);\n    padding-block-end: var(--ids-space-12);\n    display: block;\n    font-weight: var(--ids-font-weight-strong);\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n  }\n\n  &:focus {\n    z-index: 1;\n  }\n}\n\n// Adjusting hitbox for the modal close icon\n.ids-modal-icon-button {\n  padding: var(--ids-space-xs);\n}\n\n// ====================================================\n// Swipe Action Buttons (Swipe action component)\n.btn-swipe-action-left,\n.btn-swipe-action-right {\n  display: block;\n  padding: 0 var(--ids-space-xs) var(--ids-space-xs);\n  height: 100%;\n  margin: 0;\n  white-space: inherit;\n  width: 85px;\n\n  ::slotted(ids-icon) {\n    display: block;\n  }\n\n  &:hover,\n  &:focus {\n    box-shadow: none;\n    border-color: var(--ids-color-transparent);\n  }\n}\n\n// override button margin for swipe action buttons\n.ids-button:not(.no-margins).btn-swipe-action-left,\n.ids-button:not(.no-margins).btn-swipe-action-right {\n  margin: 0;\n}\n\n.btn-swipe-action-left {\n  border-start-end-radius: var(--ids-border-radius-none);\n  border-end-end-radius: var(--ids-border-radius-none);\n  background-color: var(--ids-swipe-action-color-background-left);\n  color: var(--ids-swipe-action-color-text-left);\n\n  &:active {\n    background-color: var(--ids-swipe-action-color-background-left-active);\n    color: var(--ids-swipe-action-color-text-left-active)\n  }\n\n  &:hover {\n    background-color: var(--ids-swipe-action-color-background-left-hover);\n    color: var(--ids-swipe-action-color-text-left-hover)\n  }\n}\n\n.btn-swipe-action-right {\n  border-start-start-radius: var(--ids-border-radius-none);\n  border-end-start-radius: var(--ids-border-radius-none);\n  background-color: var(--ids-swipe-action-color-background-right);\n  color: var(--ids-swipe-action-color-text-right);\n\n  &:active {\n    background-color: var(--ids-swipe-action-color-background-right-active);\n    color: var(--ids-swipe-action-color-text-right-active)\n  }\n\n  &:hover {\n    background-color: var(--ids-swipe-action-color-background-right-hover);\n    color: var(--ids-swipe-action-color-text-right-hover)\n  }\n}\n\n.ids-icon-button.gen-ai-active,\n.ids-button.gen-ai-active {\n  &:not(.no-animation) {\n    ::slotted(ids-icon[icon=\"genai\"]) {\n      display: none;\n    }\n\n    .loading-dots {\n      display: flex;\n    }\n  }\n}\n\n.ids-icon-button.gen-ai-active .loading-dots {\n  padding-inline-start: 3px;\n  padding-inline-end: var(--ids-space-3xs);\n  padding-block-start: 7px;\n  padding-block-end: var(--ids-space-xs);\n}\n\n// Applies to all non-icon button types\n.ids-button,\n.ids-toggle-button,\n.ids-menu-button:not(.ids-icon-button),\n.ids-modal-button:not(.ids-icon-button) {\n  ::slotted(ids-icon[icon=\"genai\"]:first-child) {\n    margin-inline-end: 5px;\n  }\n\n  // Padding rules for buttons that insert both text/icon into the fallback (unnamed) slot.\n  ::slotted(ids-icon:not(:first-child)) { // shadowroot + text + icon\n    margin-inline-start: 5px;\n    margin-inline-end: var( --ids-space-none);\n  }\n\n  // Padding rules for standalone CSS buttons (match the rules/style above)\n  .ids-icon:last-child,\n  span + span:not(.audible),\n  span:not(.audible):last-child {\n    padding-inline-start: 5px;\n  }\n}\n\n// Adjustment for about close icon\n.ids-modal-button {\n  ::slotted(ids-icon:not(:first-child)) { // shadowroot + text + icon\n    padding: var(--ids-space-3xs);\n  }\n}\n\n// Loading Indicator\n:host(:not([show-loading-indicator='true'])) {\n  ::slotted(.slot-loading-indicator) {\n    display: none;\n  }\n}\n\n:host([show-loading-indicator='true']) {\n  ::slotted(ids-loading-indicator) {\n    margin-top: 3px;\n    margin-bottom: 3px;\n  }\n}\n\n:host([show-loading-indicator='true'][loading-indicator-only='true']) {\n  ::slotted(*:not(.slot-loading-indicator)) {\n    visibility: hidden;\n  }\n}\n\n:host([show-loading-indicator='true']:not([loading-indicator-only='true'])) {\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-start: 6px;\n  }\n}\n\n:host([show-loading-indicator='true']:not([loading-indicator-only='true']):is([appearance='primary'], [appearance='secondary'], [appearance='primary-destructive'])) {\n  &::part(button) {\n    padding-inline-start: 20px;\n    padding-inline-end: 12px;\n  }\n\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-start: 10px;\n  }\n}\n\n:host([loading-indicator-only='true']) {\n  ::slotted(.slot-loading-indicator) {\n    position: absolute;\n    margin-inline-start: auto;\n    margin-inline-end: auto;\n    left: var(--ids-space-none);\n    right: var(--ids-space-none);\n  }\n}\n\n// Color effects on toggle button\n:host(ids-toggle-button:not(.dropdown-btn)) {\n  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-default);\n  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-default);\n}\n\n:host(ids-toggle-button[pressed]) {\n  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-default);\n}\n\n:host(ids-toggle-button[color='orange']) {\n  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-orange);\n  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-orange);\n}\n\n:host(ids-toggle-button[pressed][color='orange']) {\n  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-orange);\n}\n\n:host(ids-toggle-button[color='red']) {\n  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-red);\n  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-red);\n}\n\n:host(ids-toggle-button[pressed][color='red']) {\n  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-red);\n}\n\n:host(ids-toggle-button.ids-toggle-button-segmented) {\n  button {\n    border-radius: var(--ids-border-radius-sm);\n    font-weight: var(--ids-font-weight-normal);\n\n    &:hover {\n      color: var(--ids-segmented-control-text-color);\n      background-color: var(--ids-segmented-control-background-hover);\n    }\n  }\n}\n\n:host(ids-toggle-button.ids-toggle-button-segmented[pressed]) {\n  button {\n    color: var(--ids-segmented-control-text-color);\n    background-color: var(--ids-segmented-control-background-selected);\n    box-shadow: var(--ids-segmented-control-box-shadow);\n    border-color: transparent;\n  }\n}\n","/**\n * Ids Button Sass mixins, used in Ids Button CSS to define base styles.\n */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Mixin for a \"blank\" shadow (same as the standard one with a completely transparent alpha)\n@mixin blank-shadow() {\n  box-shadow: var(--ids-shadow-none);\n}\n\n// Used to make the focus \"border\" appear to be separated from the button (primary/secondary types).\n@mixin outset-button-shadow($bg-color, $border-color) {\n  box-shadow:\n    0 0 0 2px $bg-color, // bg color\n    0 0 0 3px $border-color\n}\n\n// Used to make the focus \"border\" on non-solid buttons (modal buttons, etc)\n@mixin modal-button-shadow() {\n  outline: 1px solid var(--ids-modal-color-outline);\n  outline-offset: -1px;\n}\n\n@mixin alternate-button-shadow() {\n  box-shadow: var(--ids-box-shadow-inverse);\n}\n\n// Used to include a basic set of button styles within each individual button prototype.\n@mixin ids-base-button-styles() {\n  @include blank-shadow();\n\n  font-weight: var(--ids-font-weight-normal);\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: var(--ids-font-size-sm);\n  overflow: hidden;\n  padding-bottom: calc(var(--ids-space-xs) - 2px);\n  padding-top: calc(var(--ids-space-xs) - 2px);\n  position: relative;\n\n  &,\n  &::before,\n  &::after {\n    box-sizing: border-box;\n  }\n\n  // Nothing inside the button itself should accept mouse events\n  * {\n    pointer-events: none;\n  }\n\n  // ====================================================\n  // Base Button styles (default/tertiary)\n\n  & {\n    border: 1px solid transparent;\n    background-color: var(--ids-color-transparent);\n    color: var(--ids-button-color-text-default);\n\n    // Animate BG/Text/Border color changes on all styles\n    transition:\n      background-color var(--ids-motion-duration) var(--ids-motion-ease),\n      border-color var(--ids-motion-duration) var(--ids-motion-ease),\n      color var(--ids-motion-duration) var(--ids-motion-ease),\n      opacity var(--ids-motion-duration) var(--ids-motion-ease);\n    white-space: nowrap;\n  }\n\n  &:focus {\n    // Disable standard focus state in Chrome\n    outline: none;\n    outline-color: var(--ids-color-transparent);\n  }\n\n  &:not([disabled]) {\n   cursor: var(--ids-cursor-pointer);\n  }\n\n  // ====================================================\n  // Standard element types inside the button\n  span {\n    vertical-align: bottom;\n\n    &.audible {\n      @include mixins.audible();\n    }\n  }\n\n  &:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon='genai'])) {\n    margin-inline-end: calc(var(--ids-space-2xs) + 3px);\n  }\n\n  .ids-icon {\n    vertical-align: middle;\n  }\n\n  // ====================================================\n  // Alignment changes\n\n  &.align-icon-end {\n    ::slotted(ids-icon) {\n      margin-inline-start: var(--ids-space-2xs);\n    }\n  }\n\n  &.content-align-start {\n    justify-content: start;\n  }\n\n  &.content-align-end {\n    justify-content: end;\n  }\n\n  &.no-margins {\n    margin-inline: var(--ids-space-none);\n  }\n\n  &.field-height-xxs:not(.btn-secondary):not(.no-margins) {\n    margin-block-start: 3px;\n    margin-inline-end: -2px;\n    height: 22px;\n    width: 22px;\n  }\n\n  ::slotted(span) {\n    // important due to reset in enterprise\n    font-weight: inherit !important;\n  }\n}\n\n/**\n * Provides standardized padding rules for certain button types\n */\n@mixin ids-standard-button-padding() {\n  padding-inline: var(--ids-button-padding-inline);\n}\n\n@mixin ids-inline-button-padding() {\n  padding-inline: var(--ids-space-12);\n}\n\n/**\n * Provides the standard color rules for all regular buttons\n */\n@mixin ids-standard-button-colors() {\n  & {\n    display: inline-flex;\n    font-weight: var(--ids-button-tertiary-font-weight);\n    border-radius: var(--ids-button-radius);\n\n    // ====================================================\n    // Default/Tertiary Button\n    background-color: var(--ids-button-tertiary-color-background-default);\n    border-color: var(--ids-button-tertiary-color-border-default);\n    color: var(--ids-button-tertiary-color-text-default);\n  }\n\n  &:not(.hide-focus).is-active,\n  &:not(.hide-focus).is-focused,\n  &:not(.hide-focus):focus,\n  &:not(.hide-focus):focus-within {\n    &:not([readonly]) {\n      border-color: var(--ids-button-tertiary-color-border-focus);\n    }\n  }\n\n  &:hover {\n    color: var(--ids-button-tertiary-color-text-hover);\n    background-color: var(--ids-button-tertiary-color-background-hover);\n    border-color: var(--ids-button-tertiary-color-border-hover);\n  }\n\n  &[disabled] {\n    color: var(--ids-button-tertiary-color-text-disabled);\n    background-color: var(--ids-button-tertiary-color-background-disabled);\n    border-color: var(--ids-button-tertiary-color-border-disabled);\n    opacity: var(--ids-button-tertiary-opacity-disabled);\n  }\n\n  &:active:not([disabled]) {\n    background-color: var(--ids-button-tertiary-color-background-pressed);\n    border-color: var(--ids-button-tertiary-color-border-pressed);\n    color: var(--ids-button-tertiary-color-text-pressed);\n  }\n\n  // ====================================================\n  // Tertiary Destructive Button\n  &.btn-tertiary-destructive {\n    background-color: var(--ids-button-destructive-tertiary-color-background-default);\n    border-color: var(--ids-button-destructive-tertiary-color-border-default);\n    color: var(--ids-button-destructive-tertiary-color-text-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-destructive-tertiary-color-border-focus);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-destructive-tertiary-color-background-hover);\n      border-color: var(--ids-button-destructive-tertiary-color-border-hover);\n      color: var(--ids-button-destructive-tertiary-color-text-hover);\n    }\n\n    &[disabled] {\n      color: var(--ids-button-destructive-tertiary-color-text-disabled);\n      background-color: var(--ids-button-destructive-tertiary-color-background-disabled);\n      border-color: var(--ids-button-destructive-tertiary-color-border-disabled);\n    }\n  }\n\n  // ====================================================\n  // Primary Button\n\n  &.btn-primary {\n    background-color: var(--ids-button-primary-color-background-default);\n    border-color: var(--ids-button-primary-color-border-default);\n    border: 1px solid var(--ids-button-primary-color-border-default);\n    color: var(--ids-button-primary-color-text-default);\n    padding-bottom: calc(var(--ids-space-xs) - 2px);\n    padding-top: calc(var(--ids-space-xs) - 2px);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-primary-color-border-focus);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-primary-color-background-hover);\n      border-color: var(--ids-button-primary-color-border-hover);\n    }\n\n    &[disabled] {\n      background-color: var(--ids-button-primary-color-background-disabled);\n      border-color: var(--ids-button-primary-color-border-disabled);\n      color: var(--ids-button-primary-color-text-disabled);\n      opacity: var(--ids-button-primary-opacity-disabled);\n    }\n\n    &:active:not([disabled]) {\n      background-color: var(--ids-button-primary-color-background-pressed);\n      border-color: var(--ids-button-primary-color-border-pressed);\n      color: var(--ids-button-primary-color-text-pressed);\n    }\n  }\n\n  // ====================================================\n  // Primary Destructive Button\n\n  &.btn-primary-destructive {\n    background-color: var(--ids-button-destructive-color-background-default);\n    border-color: var(--ids-button-destructive-color-border-default);\n    color: var(--ids-button-destructive-color-text-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-destructive-color-border-focus);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-destructive-color-background-hover);\n      border-color: var(--ids-button-destructive-color-border-hover);\n      color: var(--ids-button-destructive-color-text-hover);\n    }\n\n    &[disabled] {\n      background-color: var(--ids-button-destructive-color-background-disabled);\n      border-color: var(--ids-button-destructive-color-border-disabled);\n      color: var(--ids-button-destructive-color-text-disabled);\n      opacity: var(--ids-button-destructive-opacity-disabled);\n    }\n  }\n\n  // ====================================================\n  // Primary Generative AI Button\n  @keyframes dot-flashing {\n    0% {\n      background-color: var(--ids-button-ai-color-loading-dot-primary-step-1);\n    }\n\n    50%,\n    100% {\n        background-color: var(--ids-button-ai-color-loading-dot-primary-step-2);\n    }\n  }\n\n  @keyframes dot-flashing-colors-secondary {\n    0% {\n      background-color: var(--ids-button-ai-color-loading-dot-secondary-step-1);\n    }\n\n    50%,\n    100% {\n        background-color: var(--ids-button-ai-color-loading-dot-secondary-step-2)\n    }\n  }\n\n  @keyframes dot-flashing-colors-tertiary {\n    0% {\n      background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-1);\n    }\n\n    50%,\n    100% {\n        background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-2)\n    }\n  }\n\n  .loading-dots-start {\n    padding-inline-start: 3px !important;\n    padding-inline-end: 7px !important;\n    gap: 2px;\n  }\n\n  .loading-dots {\n    display: none;\n    position: relative;\n    flex-direction: row;\n    gap: 2px;\n    padding-inline-start: 7px;\n    padding-inline-end: 3px;\n\n    .dot {\n      display: inline-flex;\n      position: relative;\n      width: 3px;\n      height: 3px;\n      border-radius: 5px;\n      background-color: var(--ids-button-ai-color-loading-dot-default);\n      color:  var(--ids-button-ai-color-loading-dot-default);\n    }\n  }\n\n  &.btn-primary-generative-ai {\n    --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-primary-sparkle-icon-color-fill);\n\n    background: border-box var(--ids-button-ai-color-background-default);\n    border: none;\n    color: var(--ids-button-ai-color-text-default);\n    align-items: center;\n    min-width: 34px;\n    min-height: 34px;\n\n    &.compact {\n      min-width: var(--ids-button-compact-width);\n      min-height: var(--ids-button-compact-width);\n    }\n\n    &:hover {\n      background: border-box var(--ids-button-ai-color-background-hover);\n    }\n\n    &:active,\n    &.gen-ai-active {\n      background: border-box var(--ids-button-ai-color-background-active);\n      color: var(--ids-button-ai-color-text-active);\n    }\n\n    &[disabled] {\n      background: border-box var(--ids-button-ai-color-background-disabled);\n    }\n\n    &.color-variant-alternate-formatter,\n    &.color-variant-alternate-formatter:hover {\n      color: var(--ids-color-white-100);\n      min-height: var(--ids-button-formatter-size);\n      min-width: 34px;\n    }\n\n    .loading-dots {\n      .dot:nth-child(1) {\n        animation: dot-flashing 1s infinite alternate;\n        animation-delay: 0s;\n      }\n\n      .dot:nth-child(2) {\n        animation: dot-flashing 1s infinite linear alternate;\n        animation-delay: 0.5s;\n      }\n\n      .dot:nth-child(3) {\n        animation: dot-flashing 1s infinite alternate;\n        animation-delay: 1s;\n      }\n    }\n  }\n\n  // ====================================================\n  // Secondary Generative Button\n  &.btn-secondary-generative-ai {\n    --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-secondary-sparkle-icon-color-fill);\n\n    background: var(--ids-button-ai-secondary-color-background-default);\n    border: 1px solid var(--ids-button-ai-secondary-color-border-default);\n    color: var(--ids-button-ai-secondary-color-default);\n    align-items: center;\n\n    &:hover:not([disabled]) {\n      background: var(--ids-button-ai-secondary-color-background-hover);\n      color: var(--ids-button-ai-secondary-color-hover);\n      border-color: var(--ids-button-ai-secondary-color-border-hover);\n    }\n\n    &:active:not([disabled]) {\n      background: var(--ids-button-ai-secondary-color-background-active);\n      color: var(--ids-button-ai-secondary-color-active);\n      border-color: var(--ids-button-ai-secondary-color-border-active);\n    }\n\n    ::slotted(ids-icon[icon=\"genai\"]) {\n      --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);\n      --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);\n    }\n\n    &.gen-ai-active {\n      background: var(--ids-button-ai-secondary-color-background-active);\n    }\n\n    &[disabled] {\n      opacity: var(--ids-button-ai-opacity-disabled);\n    }\n\n    // Loading dots animation\n    .loading-dots {\n      .dot {\n        background-color: var(--ids-button-ai-color-loading-dot-secondary);\n        color: var(--ids-button-ai-color-loading-dot-secondary);\n      }\n\n      .dot:nth-child(1) {\n        animation: dot-flashing-colors-secondary 1s infinite alternate;\n        animation-delay: 0s;\n      }\n\n      .dot:nth-child(2) {\n        animation: dot-flashing-colors-secondary 1s infinite linear alternate;\n        animation-delay: 0.5s;\n      }\n\n      .dot:nth-child(3) {\n        animation: dot-flashing-colors-secondary 1s infinite alternate;\n        animation-delay: 1s;\n      }\n    }\n  }\n\n  // ====================================================\n  // Tertiary Generative Button\n  &.btn-tertiary-generative-ai {\n    --ids-button-tertiary-ai-shadow-focus: var(--ids-button-tertiary-shadow-focus);\n    --ids-button-ai-color-icon-secondary-hover: var(--ids-color-action-stronger);\n    --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-tertiary-sparkle-icon-color-fill);\n\n    background: var(--ids-button-ai-tertiary-color-background-default);\n    background-clip: text;\n    align-items: center;\n    color: var(--ids-button-ai-tertiary-color-text-default);\n\n    &:hover {\n      background: var(--ids-button-ai-tertiary-color-background-hover);\n    }\n\n    ::slotted(ids-icon[icon=\"genai\"]) {\n      --ids-button-ai-color-icon-primary: var(--ids-button-ai-tertiary-color-text-default);\n      --ids-button-ai-color-icon-secondary: var(--ids-button-ai-tertiary-color-text-default);\n    }\n\n    &:active,\n    &.gen-ai-active {\n      background: var(--ids-button-ai-tertiary-color-background-active);\n    }\n\n    &[disabled] {\n      background: var(--ids-button-tertiary-ai-color-background-disabled);\n      opacity: var(--ids-button-ai-opacity-disabled);\n    }\n\n    // Loading dots animation\n    .loading-dots {\n      .dot:nth-child(1) {\n        animation: dot-flashing-colors-tertiary 1s infinite alternate;\n        animation-delay: 0s;\n      }\n\n      .dot:nth-child(2) {\n        animation: dot-flashing-colors-tertiary 1s infinite linear alternate;\n        animation-delay: 0.5s;\n      }\n\n      .dot:nth-child(3) {\n        animation: dot-flashing-colors-tertiary 1s infinite alternate;\n        animation-delay: 1s;\n      }\n    }\n  }\n\n  // ====================================================\n  // Secondary Button\n  &.btn-secondary {\n    background-color: var(--ids-button-secondary-color-background-default);\n    border-width: var(--ids-button-secondary-border-width);\n    border-color: var(--ids-button-secondary-color-border-default);\n    color: var(--ids-button-secondary-color-text-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      background-color: var(--ids-button-secondary-color-background-focus);\n      border-color: var(--ids-button-secondary-color-border-focus);\n    }\n\n    &:hover:not([disabled]) {\n      background-color: var(--ids-button-secondary-color-background-hover);\n      border-color: var(--ids-button-secondary-color-border-hover);\n      color: var(--ids-button-secondary-color-text-hover);\n    }\n\n    &[disabled] {\n      background-color: var(--ids-button-secondary-color-background-disabled);\n      border-color: var(--ids-button-secondary-color-border-disabled);\n      color: var(--ids-button-secondary-color-text-disabled);\n      opacity: var(--ids-button-secondary-opacity-disabled);\n    }\n\n    &:active:not([disabled]) {\n      background-color: var(--ids-button-secondary-color-background-pressed);\n      border-color: var(--ids-button-secondary-color-border-pressed);\n      color: var(--ids-button-secondary-color-text-pressed);\n    }\n  }\n\n  // ====================================================\n  // Light Mode Alternate\n\n  // Don't apply these rules to \"alternate-formatter\"-style buttons\n  // These appear in header\n  &.color-variant-alternate {\n    &:hover {\n      background-color: rgb(0 0 0 / 0.3);\n    }\n\n    &.ids-trigger-button:not([readonly]) {\n      &:hover {\n        background-color: var(--ids-search-field-header-color-icon-hover);\n      }\n    }\n  }\n\n  // These appear in app menu\n  &.color-variant-app-menu {\n    &:hover {\n      background-color: rgb(255 255 255 / 0.15);\n    }\n  }\n\n  // These appear in places with dark background like app menu and masthead, generally default/tertiary buttons\n  &.color-variant-alternate,\n  &.color-variant-alternate-formatter {\n    color: var(--ids-button-alternate-color-text-default);\n    opacity: 0.8;\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-formatter-color-border-focus);\n      opacity: 1;\n    }\n\n    &:hover {\n      background-color: var(--ids-button-formatter-color-background-hover);\n      border-color: var(--ids-color-transparent);\n      color: var(--ids-button-formatter-color-text-hover);\n      opacity: 1;\n    }\n\n    &[disabled] {\n      background-color: var(--ids-color-transparent);\n      opacity: var(--ids-button-formatter-opacity-disabled);\n    }\n  }\n\n  // Used on Editor and List Builder \"darker\" toolbars\n  &.color-variant-alternate-formatter {\n    background-color: var(--ids-button-formatter-color-background-default);\n    border-color: var(--ids-button-formatter-color-border-default);\n    color: var(--ids-button-formatter-color-text-default);\n    height: var(--ids-button-formatter-size);\n    min-width: var(--ids-button-formatter-size);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-color-border-focus);\n    }\n\n    &[disabled] {\n      color: var(--ids-button-formatter-color-text-disabled);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-formatter-color-background-hover);\n      color: var(--ids-button-formatter-color-text-hover);\n    }\n\n    &.is-active {\n      color: var(--ids-button-formatter-color-active);\n    }\n\n    &.ids-menu-button.compact {\n      padding: var(--ids-space-2xs);\n      padding-inline: var(--ids-space-2xs);\n\n      &.square {\n        border-radius: var(--ids-border-radius-xs);\n        width: 34px;\n      }\n    }\n\n    &[editor-action='sourcemode'],\n    &[editor-action='editormode'] {\n      --ids-button-icon-width: 54px;\n    }\n  }\n\n  // Used in Tab Module Variant\n  &.color-variant-module {\n    border: 0;\n    color: var(--ids-button-module-color-text-default);\n\n    &:not(.square) {\n      border-radius: var(--ids-button-module-border-radius);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-module-color-background-hover);\n      color: var(--ids-button-module-color-text-hover);\n    }\n  }\n}\n\n/**\n * Provides the standard color rules for buttons that need box shadow\n */\n@mixin ids-standard-button-shadows() {\n  &:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai) {\n    // ====================================================\n    // Default/Tertiary Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      &:not([readonly]) {\n        box-shadow: var(--ids-button-tertiary-shadow-focus);\n      }\n    }\n\n    &.color-variant-alternate {\n      &:not(.hide-focus).is-active,\n      &:not(.hide-focus).is-focused,\n      &:not(.hide-focus).focus-within,\n      &:not(.hide-focus):focus {\n        box-shadow: var(--ids-box-shadow-inverse);\n      }\n    }\n\n    &.color-variant-alternate-formatter {\n      &:not(.hide-focus).is-active,\n      &:not(.hide-focus).is-focused,\n      &:not(.hide-focus).focus-within,\n      &:not(.hide-focus):focus {\n        box-shadow: var(--ids-shadow-20);\n      }\n    }\n  }\n\n  &.btn-tertiary-destructive {\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-destructive-tertiary-shadow-focus);\n    }\n  }\n\n  &.btn-primary {\n    // ====================================================\n    // Primary Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-primary-shadow-focus);\n    }\n\n    &.color-variant-alternate {\n      &:not(.hide-focus).is-active,\n      &:not(.hide-focus).is-focused,\n      &:not(.hide-focus).focus-within,\n      &:not(.hide-focus):focus {\n        @include outset-button-shadow(\n          var(--ids-color-primary-70),\n          var(--ids-color-text-on-primary)\n        );\n      }\n    }\n  }\n\n  &.btn-primary-destructive {\n    // ====================================================\n    // Primary Destructive Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      @include outset-button-shadow(\n        var(--ids-color-background-default),\n        var(--ids-color-error-default)\n      );\n    }\n  }\n\n  &.btn-secondary {\n    // ====================================================\n    // Secondary Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-secondary-shadow-focus);\n    }\n  }\n\n  &.btn-primary-generative-ai {\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-ai-shadow-focus);\n      border-color: var(--ids-color-transparent);\n    }\n  }\n\n  &.btn-tertiary-generative-ai,\n  &.btn-secondary-generative-ai {\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-tertiary-ai-shadow-focus);\n      border-color: var(--ids-button-ai-color-icon-secondary-hover);\n    }\n  }\n}\n\n@mixin ids-modal-button-color-defaults() {\n  // ====================================================\n  // Primary Button\n  &.btn-primary {\n    background-color: var(--ids-modal-color-background);\n    color: var(--ids-modal-button-color-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      @include modal-button-shadow();\n    }\n\n    &:hover:not([disabled]) {\n      color: var(--ids-modal-button-color-hover);\n    }\n\n    &[disabled] {\n      opacity: var(--ids-button-primary-opacity-disabled);\n    }\n  }\n\n  // ====================================================\n  // Secondary/Tertiary Button\n\n  &.btn-secondary,\n  &.btn-tertiary {\n    background-color: var(--ids-modal-color-background);\n    color: var(--ids-modal-button-secondary-color-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      @include modal-button-shadow();\n    }\n\n    &:hover {\n      color: var(--ids-modal-button-secondary-color-hover);\n    }\n\n    &[disabled] {\n      opacity:var(--ids-button-secondary-opacity-disabled);\n    }\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
